export default {
  add: "Add",
  advertisement: {
    close: "Close advertisement",
    moreInfo: "More Information"
  },
  amountConfig: {
    reducedPrice: "Reduced price",
    regularPrice: "Regular price"
  },
  assets: {
    cart: {
      battery: "Battery",
      defects: {
        active: "Available for customers",
        createDefect: "Create defect",
        deactivate: "Deactivate",
        noDefects: "No defects"
      },
      deployment: {
        debug: "Debug",
        redeploy: "Redeploy"
      },
      lastSeen: "Last seen"
    },
    chargingController: {
      charger: "Charger {index}",
      connected: "Connected",
      disconnected: "Disconnected",
      enabled: "Enabled",
      graph: {
        configure: "Configure",
        disconnected: "Disconnected",
        name: "Charger {name}",
        scheduleOverride: "Schedule override",
        shortCircuit: "Short circuit",
        toggleTimeout: "The charger did not respond in time ({timeout})",
        turnOff: "Turn off",
        turnOn: "Turn on"
      },
      health: "Health",
      issues: {
        noData: "No data from the controller since {since}",
        noDataEver: "No data from the controller",
        notConnected: "{count, plural, one {Power supply {chargers} is not connected} other {Power supplies {chargers} are not connected}}",
        shortCircuit: "{count, plural, one {Short circuit on power supply {chargers}} other {Short circuit on power supplies {chargers}}}"
      },
      off: "Off",
      on: "On",
      schedule: {
        edit: "Edit schedule",
        nextChange: "Next change: {value} at {time}",
        title: "Schedule"
      },
      shortCircuit: "Short circuit"
    },
    chargingOptions: {
      defect: "Defect",
      form: {
        confirm: "Are you sure you want to delete charging option \"{name}\"?",
        "delete": "Delete charging option",
        error: {
          serialNumberAlreadyExists: "An asset with this serial number already exists. The serial number must be unique."
        },
        lifeCycle: {
          end: "Lifecycle end",
          start: "Lifecycle start"
        },
        moveOverlay: {
          message: "Saving now will move this asset from location \"{fromLocation}\" to location \"{toLocation}\". Are you sure?",
          title: "Moving asset between locations"
        },
        name: "Name",
        product: "Product",
        productNumber: "Product Number",
        saved: "Changes have been saved",
        serialNumber: "Serial Number",
        subType: "Subtype",
        titleEdit: "Edit option {name}",
        titleNew: "Add new option",
        type: "Type",
        validations: {
          mustMatchRegex: "Value must match regex",
          required: "Required"
        }
      },
      title: "Charging Options"
    },
    common: {
      lastSeen: "Last seen",
      openMonitoring: "Open monitoring"
    },
    defects: {
      topCategories: {
        chargingCable: {
          title: "Charging cable defect"
        },
        electrical: {
          title: "Electrical issue"
        },
        housing: {
          title: "Housing defect"
        },
        other: {
          title: "Other"
        },
        powerCable: {
          title: "Power cable defect"
        },
        wheels: {
          title: "Wheels defect"
        }
      },
      unusable: "No longer usable?"
    },
    details: {
      title: "Asset details for {name}"
    },
    noConnection: "No connection",
    openDefectExists: "A defect has already been reported for this asset.",
    propertiesTitle: "Properties",
    state: {
      error: "Error",
      notOk: "Not OK",
      ok: "OK",
      warning: "Warning"
    },
    stateTitle: "State",
    title: "Assets",
    type: {
      all: "All",
      cart: "Cart",
      chargingController: "Charging Controller",
      chargingOption: "Charging Option"
    }
  },
  autoCartSetup: {
    addNew: "Add new",
    cartId: "Cart ID",
    framenumber: "Framenumber",
    modifiedBy: "Modified By",
    modifiedOn: "Modified On",
    showOld: "Show outdated",
    title: "Scheduled Setups",
    validFrom: "Valid From",
    validTo: "Valid To"
  },
  back: "Back",
  barcode: {
    barcodeContent: "Barcode Content",
    barcodeType: "Barcode Type",
    bonSequence: "Receipt Sequence",
    date: "Date",
    "else": "else",
    length: "Length",
    pfandbon: "Bottle Receipt",
    pfandbonType: "Bottle Receipt Type",
    reset: "Reset",
    storeId: "StoreID",
    workstationId: "WorkstationId"
  },
  barcodeClassification: {
    actions: {
      copyAndEdit: "Create copy and edit",
      "delete": "Delete",
      edit: "Edit",
      includeDeleted: "Include deleted"
    },
    addNew: "Add new",
    descriptions: {
      prefixChar: "some description text...",
      regex: "some description text...",
      type: "some description text..."
    },
    edit: {
      add: "Add {field}",
      addVerification: "Add verification",
      copyInfo: "You are editing a barcode classification from another scope. You can create a copy if you want to make an override for this store only",
      error: {
        cartNotSupported: "Asset metadata type \"cart\" is currently not supported",
        greaterZero: "Must be greater than zero",
        invalidRegexp: "Invalid regular expression",
        required: "Required",
        targetNeedsToBeChanged: "Target needs to be changed"
      },
      regexpDebugger: {
        matches: "Matches",
        noMatches: "No matches",
        regexp: "RegExp",
        testString: "Test string",
        title: "RegExp debugger"
      },
      remove: "Remove {field}",
      removeVerification: "Remove verification",
      targetNeedsToBeChanged: "Target needs to be changed",
      title: "Edit Barcode Classification",
      titleNew: "New Barcode Classification"
    },
    exclude: "Exclude",
    fields: {
      createdBy: "Created by",
      createdOn: "Created on",
      deletedBy: "Deleted by",
      deletedOn: "Deleted on",
      description: "Description",
      flags: "Flags",
      id: "ID",
      length: "Length",
      modifiedBy: "Modified by",
      modifiedOn: "Modified on",
      prefixChar: "Prefix",
      regex: "Regex",
      relevance: "Relevance",
      target: "Target",
      type: "Type",
      validFrom: "Valid from",
      validTo: "Valid to",
      validity: "Validity",
      verification: {
        excludeFromPos: "Exclude from POS",
        localizationKey: "Localization Key",
        message: "Message",
        options: "Options",
        title: "Verification"
      }
    },
    flags: {
      allowOneScan: "Allow One Scan",
      disableAdd: "Disabled Add"
    },
    include: "Include",
    or: "or",
    scanner: {
      classificationFailed: "Classification failed",
      debugMode: "Debug mode",
      debugModeEnabled: "Debug mode enabled",
      enterManually: "Enter barcode manually",
      lastScannedCode: "Last scanned code",
      lastScannedFormat: "Last scanned format",
      noStoreGuid: "Please select a store before scanning - barcode classification requires a store association",
      productNoStoreGuid: "You may have scanned a product. Please select a store before scanning to view product details"
    },
    target: {
      branchGuids: "Retail format",
      companyGuids: "Corporation",
      excludedStoreGuids: "Excluded Store",
      global: "Global",
      ims: "IMS",
      storeGuids: "Store",
      tenants: "Client"
    },
    tester: {
      classification: "Classification",
      code: "Barcode",
      description: "Enter a barcode to test the classifications",
      result: "Result",
      title: "Barcode Classification Tester"
    },
    types: {
      coupon: "Coupon",
      customerCard: "Customer Card",
      deposit: "Deposit",
      discountAbsolute: "Discount Absolute",
      discountPercentage: "Discount Percentage",
      employeeCard: "Employee Card",
      product: "Product"
    },
    verification: {
      options: {
        Barcode: "Barcode",
        Message: "Message",
        Product: "Product",
        Silent: "Silent"
      }
    }
  },
  barcodeScanner: {
    chromeResetCode: "Close Store Manager and rescan code found at \"Stage Now\". Please ensure you have your login data ready."
  },
  battery: {
    batteryLevel: {
      FULL: "Full",
      LOW: "Low",
      NORMAL: "Normal",
      UNKNOWN: "Unknown"
    },
    isChargerConnected: {
      "false": "Battery operation",
      "true": "Charger connected",
      unknown: "Unknown"
    },
    label: "Battery level",
    unknown: "Last known: ",
    unknownExplained: "Last data too old"
  },
  bottle: "Bottle",
  brandEditor: {
    cartBrand: {
      hint: "The cart as the customers know it.",
      title: "Cart brand"
    },
    cartBrandShort: {
      hint: "This is used as prefix for other words. E.g. \"{cartBrandShort} deals\".",
      title: "Short version of the cart brand"
    },
    cartTutorialSlides: {
      description: "Description",
      header: "Slide #{index}",
      image: "Image",
      slideTitle: "Title",
      title: "Cart UI Tutorial slides"
    },
    copy: "Copy brand colors",
    createTitle: "Brand Editor: New brand",
    customIcons: {
      addNew: "Add new",
      title: "Custom icons ({current}/{max})"
    },
    customerCards: {
      id: "Id",
      makePrimary: "Make primary",
      name: "Name",
      pointsText: "Points Text",
      pointsTextHelpMessage: "This defines the points text shown on the cart. Use '{points'} to insert the points amount.\nFor example: \"+'{points'} P\" will show as \"+100 P\" if the customer has 100 points.",
      pointsTextHelpTitle: "Points Text Help",
      primary: "Primary",
      primaryTooltip: "Primary card will be shown in areas where the customer is not signed in. E.g. on the welcome screen.",
      title: "Customer Cards"
    },
    customerIds: {
      cardLogo: "Card Logo",
      id: "ID/Barcode classification type",
      idHelp: "If collecting points is supported, this has to match the barcode classification type. If not, it can be arbitrary.",
      logoImage: "Logo Image",
      makePrimary: "Make primary",
      name: "Name",
      pointsText: "Points Text",
      pointsTextHelp: "This defines the points text shown on the cart. Use '{points'} to insert the points amount.\nFor example: \"+'{points'} P\" will show as \"+100 P\" if the customer has 100 points.",
      qrCodeImage: "App QR Code",
      showAppStores: "Show app stores",
      showOnWelcomeScreen: "Show on welcome screen",
      title: "Customer Ids",
      type: {
        card: "Card",
        mobileApp: "Mobile App"
      },
      typeTitle: "Type",
      useImageAsLogoImage: "Use App QR code or Card Logo as logo image"
    },
    editTitle: "Brand Editor: Edit {brand}",
    emails: {
      images: {
        logoEmailDarkMode: "Dark Mode",
        logoEmailLightMode: "Light Mode"
      },
      logos: "Logos",
      title: "E-Mails"
    },
    error: {
      duplicateId: "Id is already taken"
    },
    fontFamilyAlt: {
      "default": "Default",
      title: "Alternative Fonts"
    },
    general: {
      borderRadius: "Border radius (e.g. 5, 5px, 1rem, 1em)",
      title: "General settings"
    },
    headerDisplayTotal: {
      title: "Display total price in header"
    },
    headerUsePrimaryColor: {
      title: "Use primary color for header background"
    },
    highlightAddToBasket: {
      title: "Highlight add to basket button"
    },
    icons: {
      addToShoppingList: "Add to Shopping List",
      arrowBack: "Arrow Back",
      arrowLeftTutorial: "Tutorial: Left Arrow",
      arrowRightTutorial: "Tutorial: Right Arrow",
      cart: "Cart",
      cartPlus: "Cart PLUS",
      checkout: "Checkout",
      close: "Close View",
      coupon: "Coupons",
      dataPrivacy: "Data Privacy",
      door: "Exit",
      edit: "Edit",
      exit: "End Session",
      exitPopUp: "End Session Pop-Up Warning",
      flagGlutenFree: "Product Flag: Gluten-free",
      flagLactoseFree: "Product Flag: Lactose-free",
      flagOrganic: "Product Flag: Organic",
      flagRegional: "Product Flag: Regional",
      flagVegan: "Product Flag: Vegan",
      flagVegetarian: "Product Flag: Vegetarian",
      language: "Language",
      location: "Location",
      lockActive: "Lock Active",
      lockInactive: "Lock Inactive",
      navigate: "Navigate",
      navigation: "Navigation",
      payAtRegister: "Pay at Register",
      payByApp: "Pay by App",
      pluHierarchy: "PLU Hierarchy",
      pluSearch: "PLU Search",
      promotion: "Promotion",
      recipes: "Recipes",
      search: "Search",
      sosActive: "SOS Active",
      sosInactive: "SOS Inactive",
      startPayment: "Start Payment",
      startShopping: "Start Shopping",
      termsAndConditions: "Terms and Conditions",
      title: "Icons",
      tutorial: "Tutorial",
      user: "User"
    },
    id: {
      hint: "This id is used to reference a brand in config",
      title: "Id"
    },
    images: {
      background: "Background",
      cartBackground: "Background",
      enterPlu: "Enter PLU",
      logoBlack: "Black",
      logoColor: "Color",
      logoCompany: "Corporation",
      logoCustomerCard: "Customer Card",
      logoWhite: "White",
      logos: "Logos",
      none: "No image",
      title: "Images"
    },
    loyaltyCard: {
      hint: "The store's loyalty card.",
      title: "Loyalty card"
    },
    palette: {
      cartBackground: "Cart background",
      contrastText: "Contrast Text",
      customerCard: "Customer Card",
      dark: "Dark",
      discount: "Discount",
      disruptor: "Disruptor",
      free: "Free",
      light: "Light",
      main: "Main",
      navigationBackground: "Navigation background",
      primary: "Primary",
      secondary: "Secondary",
      title: "Color Palette"
    },
    paste: "Paste brand colors",
    preview: {
      title: "Preview"
    },
    priceLayoutAlt: {
      title: "Alternative price layout"
    },
    promotionsLayoutAlt: {
      title: "Alternative promotions layout"
    },
    storeBrand: {
      hint: "The store brand.",
      title: "Store brand"
    },
    table: {
      addNew: "Add new",
      confirmDelete: "Are you sure you want to delete the brand \"{brand}\"?",
      id: "Id",
      name: "Name",
      palette: "Color Palette"
    },
    title: "Brand Editor",
    validations: {
      borderRadiusPattern: "Border radius must be a number with an optional unit (px, rem, em)",
      borderRadiusPositive: "Border radius must be positive",
      duplicateCustomerCardId: "Customer card ID is already taken",
      duplicateCustomerIdId: "Duplicate, has to be unique",
      limitShowOnWelcomeScreen: "There can be a maximum of 3 customer ids shown on the welcome screen",
      noWhitespace: "Cannot contain whitespace"
    }
  },
  cancel: "Cancel",
  capacity: "{capacity}s",
  cartGenerations: {
    addCartGenerations: "Add cart generation",
    bothTypeOfWheelsError: "Multiple wheel types selected: Only one wheel type may be added to a cart generation",
    columns: {
      actions: "Actions",
      brakeWheels: "Brake Wheels",
      productNumber: "Product number",
      rampWheels: "Ramp Wheels",
      version: "Version"
    },
    noProductNumberError: "Missing: Setting a product number is required",
    noTypeOfWheelsError: "Missing wheel type: At least one wheel type must be selected",
    noVersionError: "Missing: Setting a version is required",
    title: "Cart generations"
  },
  cartInventory: {
    title: "Cart Hardware Values",
    upload: "Upload Scale Calibrations"
  },
  cartList: {
    active: "Active",
    battery: "Battery",
    batteryLevel: "Battery level",
    lastOnline: "Last online",
    loading: "Charging",
    notReachable: "Not reachable",
    notReachableDate: "Date not reachable"
  },
  cartMap: {
    highlightCart: "Highlight Cart: ",
    mapNotAvailable: "Map not available",
    showInactive: "Show Inactive Carts",
    showOlderCarts: "Show carts with a location older than 14 days",
    useNewData: "Use new data source"
  },
  cartRemoteSetup: {
    deploy: "Deploy",
    reboot: "Reboot",
    redeploy: "redeploy",
    regular: "regular",
    replace: "replace",
    submit: "Submit"
  },
  cartReplacements: {
    cartId: "Cart ID",
    framenumber: "Framenumber",
    market: "Store",
    repairDate: "Repair date",
    replacementFramenumber: "Replacement framenumber",
    ticketGuid: "Ticket Guid",
    ticketId: "Ticket ID"
  },
  cartRow: {
    by: "by",
    check: "Check inbox",
    exchange: "Swap",
    gpsDisabled: "GPS disabled",
    hasReachedPendingStatus: "Appointment follows",
    hasReachedRepairInProgressStatus: "Appointment follows",
    on: "on",
    pending: "Appointment pending",
    pickUp: "Pick up",
    remote: "Remote maintenance",
    repairDate: "Repair",
    reported: "Reported",
    returnDate: "Delivery",
    scheduled: "Appointment set"
  },
  carts: {
    active: "Active",
    backToOverview: "Return to overview",
    battery: "Battery",
    batteryOperated: "Battery operated",
    batteryStatus: "Battery Status",
    bulkDeleteValidation: {
      cannotDeleteActive: "Only deactivated carts can be deleted."
    },
    bulkReportValidation: {
      mixed: "Cannot report mixed cart types (Light and Premium) together. Please select only one type at a time.",
      settingsLoading: "Ticket settings are still loading...",
      ticketed: "Cannot report carts that already have active tickets"
    },
    cart: "Cart {cartId}",
    cartNumber: "All",
    carts: "Carts",
    cartsLocations: "Cart Locations",
    cartsWithinBoundaries: "Carts within boundaries",
    charging: "Charging",
    confirm: "Delete Cart {cartId}. Are you sure?",
    deactivateSelected: "Deactivate Selected ({count, number})",
    "delete": "Delete Cart",
    deleteSelected: "Delete Selected ({count, number})",
    deleted: "Cart {cartId} successfully deleted",
    deselectMultiple: "Cancel Bulk Selection",
    empty: "No carts set up yet",
    enablePrettyLogs: "Enable pretty logs",
    inactive: "Inactive",
    indoorMap: "Indoor Map",
    jumpToGlobalCarts: "Go to global cart view",
    lastSeen: "Reachable",
    loading: "Loading carts...",
    maintenance: "Maintenance",
    notFound: "Cart not found",
    notReachable: "Not reachable",
    onlyOutsideASession: " ONLY outside a session",
    outOfService: "Out of Service",
    outdoorMap: "Outdoor Map",
    plannedFor: "planned from ",
    reachable: "Reachable",
    repaired: "Repaired",
    reportSelected: "Report Selected Carts ({count, number})",
    selectMultiple: "Select Multiple",
    sort: "Change sorting",
    store: "Store",
    unknown: "Unknown"
  },
  cartsDefect: {
    CartTicketStatus: {
      Closed: "Closed",
      Delivered: "Delivered",
      Deployed: "Deployed",
      Dispatched: "Dispatched",
      Open: "Open",
      Pending: "Pending",
      PickupScheduled: "Pickup Scheduled",
      Processing: "Processing",
      Reminder: "Reminder",
      RepairInProgress: "Repair in Progress",
      RepairScheduled: "Repair Scheduled",
      Resolved: "Resolved",
      ReturnScheduled: "Return Scheduled",
      Returned: "Returned",
      WaitingOnCustomer: "Waiting on Customer",
      WaitingOnEdeka: "Waiting on {storeBrand}",
      WaitingOnFaytech: "Waiting on Faytech",
      WaitingOnThirdParty: "WaitingOnThirdParty",
      WaitingOnTransport: "Waiting on Transport"
    },
    addReport: "Report",
    bulkDeactivate: {
      allFailed: "All deactivations failed. Failed carts: {failedItems}",
      allSuccess: "All {count} carts deactivated successfully",
      alreadyDeactivated: "{count} already deactivated, will be skipped",
      confirm: "{count, plural, one {Deactivate # cart?} other {Deactivate # carts?}}",
      confirmButton: "Deactivate",
      partialSuccess: "{successful} of {total} successfully deactivated, {skipped} were already inactive, {failed} failed. Failed carts: {failedItems}",
      successWithSkipped: "{successful} successfully deactivated, {skipped} were already inactive",
      title: "Deactivate Carts"
    },
    bulkDelete: {
      allFailed: "All deletions failed. Failed carts: {failedItems}",
      allSuccess: "{count, plural, one {# cart deleted successfully} other {# carts deleted successfully}}",
      confirm: "{count, plural, one {Are you sure you want to DELETE # cart?} other {Are you sure you want to DELETE # carts?}}",
      confirmButton: "Delete",
      partialSuccess: "{successful} of {total} deleted, {failed} failed. Failed carts: {failedItems}",
      title: "Delete Carts",
      warning: "This action cannot be undone."
    },
    bulkReport: {
      allFailed: "All reports failed. Failed carts: {failedItems}",
      allSuccess: "{count, plural, one {Cart reported successfully} other {All # carts reported successfully}}",
      bulkReport: "Bulk report for multiple items:",
      partialSuccess: "{successful} of {total} reports successful, {failed} failed. Failed carts: {failedItems}"
    },
    closeTicket: "Cancel defect",
    closeTicketDialog: "Do you really want to close the ticket?",
    comment: "Comment:",
    deactivate: "Deactivate?",
    error: {
      "50001": "Freshdesk ticket could not be created"
    },
    missing: {
      checkbox: "Cart Missing?",
      entryMissing: "Missing",
      text: "Reporting a cart as missing will send an e-mail to the store director and all admins. By submitting this cart as 'Missing', you confirm that you have checked its last known position and that it could not be found.",
      textRemove: "Reporting a cart as 'No longer missing' will send another e-mail to the store director and all admins, notifying that the cart has been found. By submitting this cart as 'No longer missing', you confirm that it has been found.",
      title: "Report missing cart",
      titleRemove: "Remove report for missing cart"
    },
    noDefects: "None yet",
    op1: "Charging status checked",
    op2: "Cart restarted",
    op3: "Magnetic plug / socket cleaned",
    op4: "Barcode scanner cleaned",
    openDefectExists: "A defect has already been reported for this cart.",
    openDefects: "Open defects",
    problemLocation: "Where's the problem?",
    reason: "Reason:",
    report: "Report defect:",
    report2: "Reported defects",
    reset: "Reset",
    resolvedDefects: "Fixed defects",
    title: "Have the following steps been taken?",
    topCategories: {
      "0": {
        subcategories: [
          "won't turn on",
          "automatically turns off",
          "no response during session",
          "only displays \"Charging...\"-screen",
          "only displays white icons on black background",
          "no items found in search",
          "sessions don't appear at checkout-phone",
          "cannot finalize payment transaction"
        ],
        title: "Cart/Einkauf"
      },
      "1": {
        subcategories: [
          "no touch-recognition in some areas",
          "no touch-recognition at all",
          "stays off even though scanner turns on",
          "white",
          "dark/clouded visibility",
          "flickers",
          "white frame/stripes",
          "lights up in colors",
          "cracked",
          "mount loose"
        ],
        title: "Display"
      },
      "2": {
        subcategories: [
          "light off/turns off",
          "damaged case",
          "beeps multiple times without reaction",
          "cannot scan products",
          "cannot log in"
        ],
        title: "Scanner"
      },
      "3": {
        subcategories: [
          "loose",
          "broken",
          "Plexiglas dented/missing",
          "wrong LED color"
        ],
        title: "Antenna"
      },
      "4": {
        subcategories: [
          "cart has a sideward pull",
          "damaged wheel",
          "loose/missing wheel",
          "black insertion aid damaged",
          "childseat loose/broken",
          "Front shield loose/broken",
          "top packing-area loose/broken",
          "bottom packing-area loose/broken"
        ],
        title: "Mechanics"
      },
      "5": {
        subcategories: [
          "charging port loose/broken",
          "on/off button loose/broken/missing",
          "cart won't charge/shows 'Battery empty'",
          "top camera broken/no pictures",
          "bottom camera broken/no pictures"
        ],
        title: "Electronics"
      },
      "6": {
        subcategories: [
          "front shield decal coming off/missing",
          "side decal coming off/missing",
          "packing-area decal coming off/missing",
          "paint damage/scratches"
        ],
        title: "Appearance"
      },
      antenna: {
        subcategories: {
          broken: "Broken",
          loose: "Loose",
          plexiglasDetendMissing: "Plexiglas dented/missing",
          wrongLedColor: "Wrong LED color"
        },
        title: "Antenna"
      },
      appearance: {
        subcategories: {
          cameraSymbolDamaged: "Camera/Barcode scanner symbol damaged",
          cartPaintDamaged: "Cart paintwork damaged/scratched",
          frontPanelStickerIssue: "Front panel sticker comes off/is missing",
          numberStickerIssue: "Number sticker (antenna) comes off/is missing",
          numberStickerMissing: "Number sticker is missing",
          sidePanelStickerIssue: "Side panel sticker comes off/is missing",
          storageSurfaceStickerIssue: "Storage surface sticker comes off/is missing"
        },
        title: "Appearance"
      },
      cart: {
        subcategories: {
          doesNotReactWhileShopping: "Does not react while shopping",
          noProductsFound: "Search doesn't find any products",
          notStarting: "Doesn't start",
          purchaseCantBeStopped: "Session cannot be stopped",
          sessionNotShownOnEasyPhone: "Session does not appear on the {cartBrandShort} Phone",
          showsLoadingScreen: "Only displays 'Loading...'-screen",
          showsWhiteSignsOnBlackBackground: "Only displays white signs on black background",
          turnsOff: "Turns off by itself"
        },
        title: "Cart/Purchase"
      },
      display: {
        subcategories: {
          bracketLoose: "Bracket is loose",
          crackedBroken: "Cracked/broken",
          darkPoorlyVisible: "Dark/poorly visible",
          flickers: "Flickers",
          shinesColorful: "Shines colorful",
          staysOffScannerWorks: "Stays off even though scanner works",
          touchNotWorking: "Without touch function",
          touchPartiallyNotWorking: "Touch does not work in some places",
          white: "White",
          whiteLines: "Has white frame/stripes"
        },
        title: "Display"
      },
      electronics: {
        subcategories: {
          ChargingPinsBroken: "Charging pins broken off/pressed in",
          LowerCameraDefect: "Lower camera defect/no pictures",
          UpperCameraDefect: "Upper camera defect/no pictures",
          cameraDefect: "Camera defect/no pictures",
          cartDisplaysBatteryEmpty: "Cart displays 'Battery empty'",
          cartNotCharging: "Cart does not charge",
          chargingSocketLooseDefect: "Charging socket loose/defect",
          onOffSwitchLooseDefectMissing: "On/off switch loose/defect/missing"
        },
        title: "Electronics"
      },
      mechanics: {
        subcategories: {
          LowerStorageAreaLooseDefect: "Lower storage area loose/defect",
          UpperStorageSurfaceLooseDefect: "Upper storage surface loose/defect",
          cartPullsToSide: "Cart pulls to one side",
          caseDamaged: "Case damaged",
          childSeatLooseDefect: "Child seat loose/defect",
          frontPlateLooseDefect: "Front plate loose/defect",
          handleDamaged: "Handle damaged",
          insertionAidDamaged: "Black insertion aid damaged",
          reelDamaged: "Reel damaged",
          reelLooseMissing: "Reel loose/missing",
          wanzlAttatchementDefect: "Attatchement to Wanzl Cart defect",
          wanzlAttatchmentDefect: "Attatchment to Wanzl Cart defect",
          wanzlCartDefect: "Wanzl Cart defect"
        },
        title: "Mechanics"
      },
      other: {
        title: "Other"
      },
      scanner: {
        subcategories: {
          beepsNoResponse: "Beeps several times without response",
          cannotScan: "Products cannot be scanned",
          caseDamaged: "Case damaged",
          loginNotPossible: "Login not possible",
          scannerOff: "Scanner does not light up"
        },
        title: "Scanner"
      }
    }
  },
  cartsInSetup: {
    availableForSetup: "Available for setup (ALL environments of this store)",
    columns: {
      battery: "Battery",
      currentClientVersion: "Client version",
      error: "Last error",
      errorTs: "Last error timestamp",
      frameNumber: "Frame number",
      ip: "IP",
      lastSeen: "Last seen",
      productNumber: "Product number",
      status: "Status",
      wifiSignalLevel: "Wifi signal"
    },
    error: {
      SETUP_ERROR_COULD_NOT_PARSE_HARDWARE_REVISION: "Could not parse hardware revision",
      SETUP_ERROR_COULD_NOT_TALK_TO_BOARD: "Could not talk to board",
      SETUP_ERROR_MISSING_FRAME_NUMBER: "Frame number missing",
      SETUP_ERROR_MISSING_PRODUCT_NUMBER: "Product number missing"
    },
    frameNumberMissing: "Frame number missing",
    log: {
      goToDeployment: "Go to deployment",
      isSetup: "Cart has been set up successfully!",
      title: "Cart Setup Logs"
    },
    notReadyForSetup: "Not ready for setup",
    productNumberMissing: "Product number missing",
    readyForSetup: "Ready for setup",
    revertInProgress: "Revert in progress",
    revertTitle: "Revert",
    step: {
      prepare: "Prepare",
      revert: "Revert",
      setup: "Setup"
    },
    title: "Carts in Setup"
  },
  cgHierarchy: {
    allCommodityGroups: "All Product Categories",
    category: "Category",
    exclude: "Not in these categories",
    include: "Only in these categories",
    label: "Product Category",
    labelIms: "{inventoryManagementSystem} Product Category",
    labelImsMulti: "{inventoryManagementSystem} Product Categories",
    labelMulti: "{inventoryManagementSystem} Product Categories",
    noName: "[No Name]"
  },
  cgLocalKey: {
    apotheke: "Pharmacy",
    babykost: "Baby Food",
    brot_kuchen: "Bakery and Bread",
    brotaufstrich: "Spreads",
    computer: "Computer",
    diverse_nonfood: "Other",
    drogerieartikel: "Beauty and Wellness",
    feinkost: "Delicatessen",
    fette_eier: "Fats / Eggs",
    fisch: "Fish",
    freizeit: "Toys and Recreation",
    frischfisch: "Fresh Fish",
    gals_porzellan_keramik: "Home Accessories",
    garten: "Garden",
    gastronomie: "Gastronomy",
    genussmittel: "Drink and Tobacco",
    getraenke: "Beverages",
    haushalt: "Household",
    hygiene: "Hygiene Products",
    kaese: "Cheese",
    kaffee_tee_kakao: "Coffee / Tea / Cocoa",
    kleidung: "Clothing",
    knabbereien: "Snacks",
    konserven: "Canned Goods",
    mehl_salz_zucker: "Flour / Salt / Sugar",
    molkereiprodukte: "Dairy",
    nahrungsmittel: "Foodstuff",
    obst_und_gemuese: "Produce",
    reinigungsmittel: "Detergents",
    speisezutaten: "Condiments",
    suesswaren: "Candy",
    tags: "Tags",
    telekommunikation: "Telecommunication",
    tiefkuehlkost: "Frozen Foods",
    tierbedarf: "Pet Supplies",
    warengruppen_dauerhafte_artikel: "Permanent Goods",
    wuerzmittel: "Spices",
    wurst_fleisch: "Meats and Sausages",
    wurstwaren_und_kaese: "Wurstwaren & Käse"
  },
  checkout: {
    actions: {
      addBookmark: "Bookmark session",
      camera: "Camera",
      checkSessionVideo: "Request video URL/check upload status",
      checkVideoStatus: "Check video status",
      demoMode: "Demo mode",
      downloadSessionNotPossible: "No video available",
      downloadSessionVideo: "Download video",
      downloadSessionVideoRequest: "Request video url",
      emergencyPayment: "Emergency payment",
      emergencyPaymentMessage: "Please scan this code at the cart scanner to activate emergency payment",
      help: "Help",
      helpAtCart: "Self-checkout",
      helpAtRegister: "Pay at checkout",
      helpExpress: "Express shopping",
      loginCode: "Admin Code",
      markSuspicious: "Mark as suspicious",
      moreOptions: "More options",
      randomCheck: "Open Random Checks",
      removeBookmark: "Remove bookmark from session",
      removeBookmarkDialog: {
        message: "Removing this bookmark will result in the session video being deleted from the cloud. If the session is recent, it could still be present in a local store. Do you want to continue and potentially permanently delete the video?",
        no: "No, keep",
        title: "Remove bookmark? Video may be deleted",
        yes: "Yes, remove"
      },
      scanner: "Adjust Handscanner",
      scannerInfoText: "Scan each code in the right order to reconfigure your handheld scanner.",
      sessionDurationAndPrice: "Session duration and total",
      showTaken: "Show all",
      videoUploadStatus: {
        action: "Session video status",
        error: {
          noVideoFound: "No video found",
          noVideoWasRequested: "No video upload requested yet",
          videoDeleted: "Video was deleted"
        },
        request: "Request video upload",
        status: {
          failed: "Failed",
          noVideoFound: "No video found",
          noVideoWasRequested: "No video upload requested yet",
          pending: "Pending",
          success: "Success",
          videoDeleted: "Video was deleted"
        },
        title: "Video upload status"
      }
    },
    historic: {
      back: "Return to overview",
      captureDate: "Debit date",
      captureStatus: "Capture",
      cashier: "Cashier",
      creditCard: "Credit Card",
      debitDate: "Debit date",
      directDebit: "Direct debit",
      loginType: "Login type",
      mpos: {
        MPOS: "V1",
        MPOSv2: "V2",
        title: "MPOS",
        v1: "MPOS V1",
        v2: "MPOS V2"
      },
      noPayments: "No payments available",
      notFound: "Session not found",
      payment: "Payment",
      postProcessingBy: "Post-processed by",
      receiptNr: "Receipt no.",
      receiptNumber: "Receipt no.",
      title: "Previous payment"
    },
    history: {
      bookmark: "Bookmark",
      bookmarked: "Bookmarked",
      cart: "Cart Number",
      creditCard: "CreditCard",
      customerGuid: "Customer GUID",
      date: "Date",
      edekaAppPayment: "App-Payment: EDEKA",
      endTime: "Until",
      fallbackPaymentMessage: "This session was paid by scanning the Payment Fallback code at the cart.",
      filter: "Filter",
      maxTotal: "Max",
      minTotal: "Min",
      noPayment: "Sessions without payment",
      parkingEan: "Parking EAN",
      paymentCredit: "App-Payment: CreditCard",
      paymentDebit: "App-Payment: DebitCard",
      qrPayments: "QR-Payments",
      receiptNo: "Receipt Number",
      reload: "Reload",
      resolveCustomerNotAllowed: "This feature is not active",
      resolveCustomerNotFound: "Customer not found",
      resolveSessionNotFound: "Session not found",
      resolvingScan: "Processing scan...",
      resolvingUnknownCode: "Unknown code",
      sessionGuid: "Session GUID",
      showGuids: "Show Guids",
      showPaymentCodes: "Show Payment Codes",
      startTime: "From",
      title: "Session history",
      unknownError: "Unknown Error: {error}"
    },
    notifications: {
      paymentIntervention: {
        body: "{reason} ({time})",
        reasons: {
          pendingVerification: "Needs verification"
        },
        title: "{device}: Manual intervention required"
      }
    },
    overview: {
      noPayments: "No open payments",
      openOfflinePayments: "App Payment available",
      openOfflinePaymentsOld: "Offline EC-Payment",
      showFallback: "A payment does not appear?",
      showTaken: " Claimed payments are shown"
    },
    payment: {
      WeightWithoutScan: {
        beforeImage: "Before",
        currentImage: "Current",
        description: "{count, plural, one {Possible unscanned item} other {Possible unscanned items}}",
        reasons: {
          barcodeArticleAdded: "Barcode Product",
          cancelled: "Service Cancelled",
          customerNegated: "Customer Negated",
          other: "Other",
          personalItemAdded: "Personal Item",
          pluArticleAdded: "PLU Product"
        },
        title: "Possible unscanned item(s)"
      },
      alreadyCanceled: "Payment process canceled.",
      alreadyCompleted: "Payment process complete.",
      appPayment: "App Payment",
      backToOverview: "Return to overview",
      bookmarkedSession: "Bookmarked session",
      complete: "Finalize",
      completeCheck: "Complete Check",
      completePayment: "Carry out payment",
      completeVerifications: {
        app: "The customer may now pay via app",
        selfCheckout: "The customer may now pay at the self-checkout"
      },
      creditCard: "Credit card",
      customerCard: "Customer reward card",
      customerCheckFailed: "Check failed",
      debitCard: "Debit card",
      details: "Details",
      doesNotExist: "Payment process not available.",
      easyCreditCard: "{cartBrandShort} Credit Card",
      easyCreditCardButtonHasBeenPressed: "{cartBrandShort} Credit Card pressed",
      easyDirectDebit: "{cartBrandShort} Direct Debit",
      easyDirectDebitButtonHasBeenPressed: "{cartBrandShort} Debit Card pressed",
      ecOfflineButtonHasBeenPressed: "Offline-EC pressed",
      employeeCard: "Employee discount card",
      error: {
        "0": "ok",
        "1": "Input {value} is not valid",
        "2": "Item {value} has already been scanned",
        "3": "Store was not found",
        "4": "Session was not found",
        "5": "Payment request was not found",
        "6": "Verification item was not found",
        "7": "Scanned code is not a product {value}",
        "8": "The item was processed by a different request"
      },
      express: "Express register",
      markedAsSuspicious: "Marked as suspicious",
      menu: {
        back: "Return to previous step",
        cancel: "Cancel payment",
        cancelFailedRandomCheck: "Continue payment and re-scan items at this checkout",
        cancelRandomCheck: "Cancel Random Check",
        details: "Details",
        moveDevice: "QR Code for 2. device",
        moveDeviceHide: "Hide QR Code for 2. device",
        moveDeviceShow: "Show QR Code for 2. device",
        release: "Release cart",
        setupScanner: "Setup scanner",
        switchToEAN: "Switch to restoration EAN",
        switchToQR: "Switch to QR codes"
      },
      noExpress: "Register not available",
      offlineAutoCloseHint: "After processing at the register the payment will be closed automatically",
      offlineCreditVerification: "This payment must be booked with \"{cartBrandShort} Credit-payment\" at the register(!)",
      offlineDebitVerification: "This payment must be booked with \"{cartBrandShort} Debit-payment\" at the register(!)",
      offlineEc: "Offline-EC",
      offlineEcVerification: "This payment must be booked with \"Offline EC-Payment\" at the register(!)",
      paymentCodes: "Payment Codes",
      paymentRejected: {
        message: "We are sorry, but your payment was rejected. Please try again",
        title: "Payment Rejected"
      },
      posProcessing: "Register processes",
      processes: "Processes",
      products: "Products: {total}",
      rescanCustomerApp: {
        fallbackCustomerApp: "Customer App",
        message: "{customerApp} app connection failed! Please scan {customerApp} app directly at the register before continuing!",
        title: "Please rescan the {customerApp} app",
        verificationItemMessage: "Please rescan the {customerApp} app before payment.",
        verificationItemTitle: "Connection to {customerApp} app failed!"
      },
      scanAll: "Please scan all items in the cart and end the session through the admin menu.",
      scanEAN: "Scan barcode",
      scanQR: "Scan QR",
      sessionCode: "Session code",
      title: "Register",
      verification: {
        ImageDetectionUnscannedProduct: {
          message: "\"{className}\" recognized but not scanned. Please double-check.",
          title: "Unscanned product"
        },
        ageCheck: {
          details: "Age restricted item(s) {age, number} years:",
          message: "Does the customer meet the required minimum age?",
          title: "Minimum age"
        },
        bottleBundleCheck: {
          message: "{checkItemCount, plural, one {Please make sure the following product isn't a bundle:} other {Please make sure the following # products aren't bundles:}}",
          title: "Bottle/bundle check"
        },
        checkAgeRestrictionMagazine: {
          message: "Age-restricted content: Please check magazine(s)! "
        },
        checkForEmptyCrate: {
          message: "The customer has multiple of the following bottles but stated to have no crate. Please check for a crate.",
          title: "Check for crate"
        },
        collect: {
          message: "Please remember items for pick up: {itemNames}",
          title: "Item(s) for pick up"
        },
        collectCoupon: {
          message: "Collect coupon with EAN {couponEan}!",
          title: "Collect coupon"
        },
        collectCoupons: {
          message: "{count, plural, one {Collect one coupon} other {Collect # coupons}}"
        },
        collectLoyaltyCard: {
          message: "Collect loyalty points!"
        },
        deposit: {
          message: "Collect deposit coupon(s): ",
          title: "Deposit coupon"
        },
        details: "Details",
        discount: {
          message: "{count, number} Discount Scans",
          saved: "Customer saving: {total}",
          title: "Discount Scans"
        },
        employeeCardDisabled: {
          message: "Please scan the employee card at the register",
          title: "Employee card"
        },
        explosives: {
          message: "Explosives:",
          title: "Products for inspection"
        },
        express: {
          loading: "Loading pictures",
          message: "Select an express register to check basket pictures.",
          noPictures: "Disabled",
          title: "Select express register"
        },
        loyalty: {
          message: "Coupon booklets: {itemNames}",
          title: "Coupon booklets"
        },
        more: {
          title: "More"
        },
        multipleCodesToScan: {
          continueAtRegister: "Continue at register",
          continueAtSCO: "Continue at self-checkout",
          message: "Multiple codes to scan!\n\nPlease make sure that all displayed codes are scanned.",
          title: "Multiple codes to scan"
        },
        notImplemented: "Unknown type of verification: {type}",
        oneCodeToScan: {
          message: "One code to scan!\n\nPlease make sure that the displayed code is scanned.",
          title: "One code to scan"
        },
        paymentExists: {
          bookAgain: "Book purchase again",
          closeSession: "Close session",
          label: "Payment Exists",
          title: "Payment has already been successfully booked"
        },
        posProcessing: {
          employeeCard: "Employee discount card",
          "mpos-unknown-product": "MPOS unknown item: {itemName} {price} (item id {rootItemId}, product group {commodityGroupId})",
          printPinForPhoneCardOrVoucher: "Print PIN for phone card or voucher",
          title: "Register processes"
        },
        randomCheck: {
          balanceRandomChecks: "Balance random checks",
          cameraOff: "Camera off",
          cameraOn: "Scan with camera",
          canceledMessage: "Random Check cancelled",
          cashFailure: "Cash Failure",
          choseReason: "Choose a reason: ",
          completeCheck: "Complete Check",
          completeCheckDescription: "When this feature is enabled, the payment process will skip directy to a message alerting the cashier to scan all the products by hand and close the session manually through the admin menu.",
          completeMessage: "Random Check complete",
          continueHere: "Continue on this device",
          countRemovedProducts: "Count of removed products",
          customerFailed: "Random Check failed",
          customerFailedDescription: "At least one random check item was not found in the customer's virtual basket",
          customerFailedPartTwo: "Please send the customer to a regular checkout.",
          customerFailedSendToCheckout: "Please send the customer to a regular checkout",
          customerMark: "Should the customer's next purchase be checked?",
          customerSelectedHomogenous: "Customer has scanned non-homogenous!",
          customerSelectedHomogenous2: "Please correct the product selection at the checkout.",
          customerTraffic: "High customer traffic",
          eanPlu: "EAN/PLU",
          enableForExpressShopping: "Random check for express shopping",
          enableForPaymentAtCart: "Random check for pay-by-app",
          finished: "Finished! You may now go back to the checkout process.",
          ignored: "Ignored: ",
          ignoring: "“{ignoredScan}”",
          imageDetections: {
            doYouRecognizeClass: [
              "Do you recognize:",
              "{classificationClassName}",
              "in this image?"
            ]
          },
          markReason: {
            irregularities: "Irregularities",
            markedOn: "Marked on",
            potentialDamage: "Potential damage",
            shoppingOn: "Shopping on"
          },
          message: "{count, plural, one {Please remove # randomly selected product from the cart and scan it with the {cartBrandShort} phone.} other {Please remove # randomly selected products from the cart and scan them with the {cartBrandShort} phone.}}",
          messagePlaceholder: "Please take a randomly selected product from the cart and scan it with the {cartBrandShort} phone.",
          messageWithDetections: "{count, plural, one {Please remove # product from the cart and scan it with the {cartBrandShort} phone.\nPay particular attention to:} other {Please remove # products from the cart and scan them with the {cartBrandShort} phone.\nPay particular attention to:}}",
          modification: "Modification",
          multiSessionTriggerThreshold: "Amount of sessions triggering a random check",
          noScanDevice: "No {cartBrandShort} Phone Scanner",
          productTrigger: "Product Trigger",
          productTriggerInput: "EANs or Item IDs",
          removedProducts: "Removed Products",
          scan: "Scan",
          scanAnItem: "Please scan an item...",
          scanQr: "Scan this QR Code with an {cartBrandShort} Phone to continue the random check on another device",
          scannedEnough: "You already scanned enough products.",
          showReplaced: "Not homogenous",
          siblings: "Customer's items with the same product group:",
          startMessage: "Start Random Check",
          technicalDifficulties: "Technical Difficulties",
          title: "Random check",
          totalRemovedProducts: "Total value of removed products",
          typeBarcode: "EAN/PLU",
          typeBarcodeMsg: "Please enter the EAN or PLU in the field.",
          typeIn: "EAN/PLU"
        },
        selfCheckoutOption: {
          message: "Please select the type of checkout",
          title: "Self-checkout / regular checkout"
        },
        suspicious: {
          message: "Items removed before payment:",
          title: "Items removed"
        },
        unknownBarcode: {
          message: "{count, plural, one {Other Unknown Barcode} other {Other Unknown Barcodes}}",
          subtitle: "Removed by customer",
          title: "Other unknown barcodes"
        },
        wantedUnknownBarcode: {
          subtitle: "Customer wants to buy item",
          title: "Unknown Item / Barcode"
        }
      }
    },
    tabs: {
      atCart: "App payment",
      atCartOld: "OFFLINE - EC (App)",
      atRegister: "At checkout",
      history: "History"
    },
    title: "Checkout"
  },
  clear: "Clear",
  clicktoCopy: "Click to copy",
  close: "Close",
  collapse: "Show less",
  commodityGroup: {
    classificationNetworks: {
      add: "Add classification network",
      canOnlyEditGlobally: "Classification networks can only be edited in the global product category view.",
      description: "Classification networks assigned to this product category. Includes direct assignment as well as inherited ones.",
      title: "Classification Networks"
    },
    columns: {
      classificationNetworks: "Classification Networks",
      disableBasketRemoval: "Disable Basket Removal",
      disableManualPricing: "Disable Manual Pricing",
      disabledDiscountCodes: "Disabled Discount Codes",
      flags: "Flags",
      fullId: "ID",
      icon: "Icon",
      inventoryManagementSystem: "Inventory Management System",
      labels: "Labels",
      localizationKey: "Category",
      name: "Name",
      positions: "Positions"
    },
    details: {
      title: "Product Category Details"
    },
    editMessage: [
      "Note that changes made to product categories can also be applied to its subgroups (if they don't have the same property defined).",
      "Changes to labels will not be propagated to products immediately, but may only be available after a nightly recalculation."
    ],
    flatView: "Flat view",
    inheritedFromGlobalGroup: "Inherited from global product category {group}",
    inheritedFromStoreGroup: "Inherited from store product category {group}",
    labels: {
      add: "Add label",
      canOnlyEditGlobally: "Labels can only be edited in the global product category view.",
      description: "Labels assigned to this product category. Includes direct assignment as well as inherited ones.",
      hasExplicitLabels: "Has explicit labels",
      hasLabels: "Has labels",
      title: "Labels"
    },
    layout: {
      fullscreen: "Layout: Fullscreen",
      horizontal: "Layout: Horizontal",
      vertical: "Layout: Vertical"
    },
    metadata: {
      disabledDiscountCodes: {
        add: "Add disabled discount code"
      },
      flags: {
        add: "Add flag"
      },
      icon: {
        noIcon: "No icon",
        unknownIcon: "Unknown icon"
      },
      title: "Metadata"
    },
    reset: "Reset",
    selectInventoryManagementSystem: "Inventory Management System",
    title: "Product Categories"
  },
  config: {
    cart: "Cart",
    context: "Context",
    emptyString: "empty string",
    filters: "Filters",
    group: "Group",
    inventorySystem: "EBUS/RWWS",
    key: "Key",
    layer: "Layer",
    levels: {
      "0": "Cart",
      "1": "Store",
      "2": "Client",
      "3": "Global",
      "5": "Default value"
    },
    saveConfirmation: "Sure that the following changes should be saved?",
    service: "Service",
    store: "Store",
    target: "Target",
    tenant: "Client",
    toReset: "To reset: ",
    toUpdate: "To update: ",
    tooltipClear: "Remove config value",
    tooltipTarget: "Sync targets:",
    tooltipType: "Type:",
    type: "Type",
    validation: {
      mustNotBeEmpty: "Must not be empty",
      numberNotInteger: "Must be integer",
      numberNotValid: "Must be valid number",
      numberTooLarge: "Must be at most {max}",
      numberTooSmall: "Must be at least {min}",
      stringDoesntMatchRegex: "Must match regex: {regex}",
      stringTooLong: "Must be at most {maxLength} characters long",
      stringTooShort: "Must be at least {minLength} characters long"
    }
  },
  confirm: "Confirm",
  "continue": "Continue",
  coordinateSelector: {
    pleaseSelect: "Please select a location",
    search: "Searching location"
  },
  copied: "Copied",
  customValue: "Custom value:",
  customer: {
    appVersion: "App Version",
    changeFlags: "Change Flags",
    customerHistory: {
      add: "added the label on",
      create: "created the label on",
      "delete": "deleted the label on",
      update: "updated the label on"
    },
    customerInfo: "Customer Information",
    customerNr: "Customer Number",
    device: "Device",
    infoLogin: "Type Login Hash",
    infoScan: "Scan user QR Code",
    lastSession: "Last Session",
    noPayment: "No payment methods available",
    notFound: "Could not find a customer with the Login Hash {hash}",
    or: "or",
    os: "OS",
    paidSessions: "Paid Sessions",
    payment: "Payment Methods",
    paymentCompletedOn: "Last Payment",
    search: "Search for a customer",
    userGuid: "UserGuid"
  },
  customerDetails: {
    customer: "Customer"
  },
  day: {
    friday: "Friday",
    monday: "Monday",
    saturday: "Saturday",
    sunday: "Sunday",
    thursday: "Thursday",
    tuesday: "Tuesday",
    wednesday: "Wednesday"
  },
  days: {
    friday: "Friday",
    monday: "Monday",
    saturday: "Saturday",
    "short": {
      friday: "Fr",
      monday: "Mo",
      saturday: "Sa",
      sunday: "Su",
      thursday: "Th",
      tuesday: "Tu",
      wednesday: "We"
    },
    sunday: "Sunday",
    thursday: "Thursday",
    tuesday: "Tuesday",
    wednesday: "Wednesday"
  },
  deals: {
    automatic: "The coupon is redeemed automatically when you purchase the product with the {cartBrand}.",
    description: "Description",
    noValidDeals: "No valid deals at the moment",
    notCombinable: "The coupon can be redeemed several times, but cannot be combined with other discount campaigns.",
    notCombinable2: "On sale only in common household quantities.",
    paybackDisclaimer: "PAYBACK Extra° points received through products will only be displayed on the receipt.",
    productDescription: {
      text1: "The discount applies to a maximum of 32 kg purchased on the same receipt.",
      text2: "Promotion valid within the limit of available stock!",
      title: "Product description"
    },
    remainingDays: "{days, plural, one {# day left} other {# days left}}",
    remainingHours: "{hours, plural, one {# hour left} other {# hours left}}",
    unit: "per {unit}",
    valid: "Valid until {endDate}",
    validToday: "Only valid today"
  },
  defects: {
    columns: {
      cartId: "Cart ID",
      changedBy: "Changed By",
      createdOn: "Created On",
      extCreatedOn: "Created On (External)",
      extModifiedOn: "Modified On (External)",
      framenumber: "Framenumber",
      modifiedOn: "Modified On",
      note: "Note",
      priority: "Priority",
      reasons: "Reasons",
      repairDate: "Repair Date",
      returnDate: "Return Date",
      status: "Status"
    }
  },
  "delete": "Delete",
  deployment: {
    activities: {
      title: "Activities"
    },
    alreadyDeploymentGroupDefault: "{count, plural, one {Deployment Package is default for \"{deploymentGroup}\" } other {Deployment Package is default for \"{deploymentGroup}\" (and others)}}",
    alreadyGlobalDefault: "Deployment Package is Global default",
    alreadyStoreDefault: "Deployment Package is Store default",
    assignDeployment: "Assign deployment:",
    cartCreate: {
      advanced: "Advanced options",
      auto: "Auto",
      cartId: "Cart ID",
      deploy: "Deploy",
      fakeUwbTagVersion: "Fake UWB Tag Version",
      "for": "For",
      message: "Scan the Aztec code on the cart to carry out the setup:",
      reboot: "Reboot",
      setupType: "Setup Type",
      skipBatteryCheck: "Skip battery check",
      skipHardwareCheck: "Skip hardware check",
      skipSelfUpdate: "Skip self update",
      success: "Cart logged in"
    },
    columns: {
      cartGuid: "Cart GUID",
      cartIp: "Cart IP",
      cartMac: "Cart MAC",
      currentPackage: "Installed Package",
      deploymentAssigner: "Deployment Assigner",
      deploymentServiceVersion: "Deployment Service Version",
      desiredPackage: "Assigned Package",
      frameNumber: "Frame number",
      lastSeen: "Last contact",
      link: "Link",
      name: "Store/Cart/Group",
      status: "Status"
    },
    comparePackages: {
      columns: {
        base: "Base package",
        other: "Other package",
        variable: "Variable"
      },
      comparingBaseAgainst: [
        "Comparing base package",
        "{basePackage}",
        "against package",
        "{otherPackage}"
      ],
      different: "{count} different",
      empty: "Empty",
      missing: "{count} missing",
      noNameSet: "Name not set",
      openComparison: "Open comparison view",
      same: "{count} same",
      selectPackageToCompareAgainst: "Select package to compare against",
      templateVersion: "Template Version",
      title: "Compare packages"
    },
    create: {
      askSelectBase: "Select another package as base?",
      basedOn: "Based on: {name}",
      createDeploymentPackage: "Create deployment package",
      dev: "DEV",
      failed: "An error has occurred:",
      markAsExperimental: "Mark deployment package as experimental",
      promotedVersion: "Promoted version",
      selectBase: "Select another package as base",
      setAllTo: "Set all versions to {version}",
      setAsDeplyomentGroupDefault: "Set deployment package as default for a Deployment Group",
      setAsGlobalDefault: "Set deployment package as global default",
      setAsStoreDefault: "Set deployment package as store default",
      test: "TEST",
      title: "New deployment package",
      value: "Value",
      variable: "Variable"
    },
    createCart: "Create cart",
    createdPackages: "Created",
    deploy: {
      afterOpeningHours: "Closing time",
      assign: "Assign deployment: ",
      later: "Later",
      now: "Now",
      reset: "Are you sure you want to reset the Store default package?",
      resetButton: "Reset the Store default package",
      selectATime: "Select a time...",
      selectAnEndTime: "Select an end time...",
      windowEnd: "Window end",
      windowRepeatsDaily: "Repeats daily between these times. Leave empty to switch off this step.",
      withoutSession: "Only outside a session"
    },
    deploymentGroupDefaultPackage: "{count, plural, one {Default package for deployment group: {deploymentGroups}} other {Default package for deployment groups: {deploymentGroups}}}",
    details: {
      copy: "New package base on this one",
      distribuition: "Distribuition: ",
      doesNotExist: "This deployment does not exist"
    },
    errors: "{errorCount, plural, one {# Error!} other {# Errors!}}",
    errorsRoute: {
      title: "Errors"
    },
    experimental: {
      dialog: {
        message: "You are about to deploy an experimental deployment package. Are you really sure?",
        title: "Warning: Experimental Deployment Package"
      },
      label: "Experimental",
      selected: "Selected package is"
    },
    globalDefaultPackage: "Global default package",
    groups: {
      newGroup: "New Group",
      title: "Deployment Groups"
    },
    history: {
      deploymentDetailsNotFound: "No details found in current store for this deployment",
      title: "History"
    },
    isDefaultPackage: "Default package",
    list: {
      create: "Create",
      name: "Name",
      noPackages: "No Deployment Packages yet.",
      template: "Template",
      title: "Deployment Packages"
    },
    loading: "Loading...",
    log: {
      cancelDeploy: "Cancel Redeployment",
      debug: "Debug",
      deploymentTime: "Set deployment times: ",
      noDeploymentAssigned: "No deployment assigned",
      requested: "Requested",
      rolledOut: "Rolled out"
    },
    noGroup: "No Group",
    overview: {
      title: "Deployment Overview",
      titleStore: "{storeName} - Deployment Overview"
    },
    promoted: {
      create: {
        required: "Required",
        title: "Promote version"
      },
      deletedBy: "Deleted by",
      deletedOn: "Deleted on",
      details: {
        notPromoted: "This version is not promoted.",
        title: "Promoted version {version}"
      },
      list: {
        "delete": "Remove ",
        includeDeleted: "Include deleted?",
        title: "Promoted versions"
      },
      name: "Service",
      promotedBy: "Promoted by",
      promotedFor: "Environment",
      promotedOn: "Promoted on",
      promotedVersionGuid: "Guid",
      promotionReason: "Reason",
      validTo: "Valid until",
      version: "Version"
    },
    reDeploy: {
      onlyRepeatFailed: "Repeat only failed",
      redeploy: "Redeploy"
    },
    recurring: {
      completed: "Last finished",
      done: "done",
      downloading: "downloading",
      failedAt: "Last attempt failed at",
      failedWaiting: "Last attempt failed — Next window pending",
      failedWaitingDetail: "The attempt limit for this window is exhausted. It can run again in a later daily window when the cart is eligible. Freeing disk space does not retry it in this window. Open the deployment details for command output.",
      lastChanged: "Waiting since",
      never: "Has not run yet",
      notBefore: "First window not before",
      off: "off",
      offDetail: "No window set, so the nightly download is switched off.",
      purpose: "Downloads OS updates overnight, ahead of the deployment that installs them.",
      running: "running",
      scheduled: "scheduled",
      started: "Started",
      unknownAttemptTime: "Last attempt time unavailable",
      waiting: "waiting",
      window: "Every day {from}–{to} UTC",
      withheld: "withheld",
      withheld_cartTooOld: "The cart's software is too old to run a nightly download, so the store left this step out of its deployment. It needs a newer build before the window can be used.",
      withheld_notReassignedYet: "The cart can run this now, but its deployment was built before it could, and the store does not revise a deployment already created. It picks the step up with its next deployment package."
    },
    row: {
      deploymentCreated: "Deployment created",
      noContactSinceAssignment: "No contact since assignment"
    },
    selected: {
      carts: "{count, plural, one { # cart } other { # carts }}",
      title: "Selected",
      wholeStores: "{count, plural, one { # whole store } other { # whole stores }}"
    },
    setDefaultPackageTooltip: "Change default package",
    setGroupDialog: {
      group: "Deployment Group",
      submit: "Set as default",
      text: "The current deployment package will be used as the default for the following Deployment Group",
      title: "Choose Deployment Group"
    },
    setupType: {
      redeploy: "redeploy",
      regular: "regular",
      replace: "replace",
      testCart: "testCart"
    },
    statusBucket: {
      FAILED: "Failed",
      FAILED_detail: "A step did not complete. Open a cart for its output.",
      INPROGRESS: "In progress",
      INPROGRESS_detail: "Running a deployment step right now.",
      SUCCESSFUL: "Deployed",
      SUCCESSFUL_detail: "On the package they were assigned.",
      WAITING: "Waiting",
      WAITING_OFFLINE: "Not heard from",
      WAITING_OFFLINE_detail: "No contact for a while — these are the ones worth looking into.",
      WAITING_QUEUED: "Ready, not started",
      WAITING_QUEUED_detail: "Nothing is holding these back but the queue.",
      WAITING_SCHEDULED: "Waiting for its time",
      WAITING_SCHEDULED_detail: "Nothing is wrong: the next step is not due yet.",
      WAITING_detail: "Reported by a service that predates the breakdown above.",
      cartsSeen: "Heard from {seen} of {total} carts",
      title: "Carts by state"
    },
    storeDefaultPackage: "Store default package",
    technicalCodes: {
      codeForSetupWifi: "Code for Store Setup Wi-Fi",
      enterTransportationMode: "Enter transportation mode",
      openEasytest: "Open Easytest",
      revert: "Revert/Factory state",
      scanForWifiChange: "Scan the Aztec code on the cart to change the Wi-Fi network:",
      title: "Codes for setup service",
      useSetupWifi: "Use Store Setup Wi-Fi settings",
      wifiChange: "Wifi change"
    },
    tooltip: {
      allCarts: "All Carts",
      allFailedCarts: "All Failed Carts",
      deploy: "Deploy",
      redeploy: "Redeploy",
      schedule: "Schedule",
      transfer: "Transfer",
      transferDisabled: "Need to select individual carts"
    },
    validation: {
      storeProxyIp: "Please enter a valid IP address"
    }
  },
  deposit: "Deposit",
  dev: "DEV",
  deviceType: {
    cart: "Cart",
    express: "Express"
  },
  devops: {
    availableApt: "Available APT",
    availableDocker: "Available Docker",
    buildMonitor: "Build Monitor",
    cartDashboard: "Cart Dashboard",
    carts: "Carts",
    configs: "Configs",
    configsCompare: "ConfigsCompare",
    dataSync: {
      connected: "Connected",
      connectionState: "Connection state",
      disconnected: "Disconnected",
      multiple: "Multiple active connections: {count}",
      retainedHistory: "Retained connection history"
    },
    git: "Git",
    latestApt: "Latest APT",
    latestDocker: "Latest Docker",
    stores: "Stores",
    storesEmptySearch: "No store matched your search",
    table: {
      expectedVersion: "Expected",
      outdated: "Outdated",
      serviceName: "Service",
      serviceVersion: "Version",
      store: "Store",
      upToDate: "Up-to-date"
    }
  },
  download: "Download",
  dsi: {
    actions: {
      additionalInfo: "Additional Information",
      annotating: "Annotating",
      debugShowDisabledClasses: "DEBUG: Show disabled classes",
      exportPdf: "Export Report PDF",
      labelling: "Labelling",
      showImageClassifications: "Show image classifications",
      showImageDetections: "Highlight objects"
    },
    actualWeight: "Actual Weight",
    amount: "Amount",
    analyse: "Analyse",
    appliedDiscount: "Applied Discount",
    articles: "Items",
    basketChange: {
      gtin: "GTIN",
      measuredWeight: "Measured Weight",
      price: "Price",
      productWeight: "Product Weight",
      source: "Source"
    },
    bottleBundleCheck: {
      basketItemGuid: "Basket item GUID",
      bundleWeight: "Bundle weight",
      capacity: "Capacity",
      createdOn: "Created On",
      customerApproved: "Customer Approved",
      customerApprovedOn: "Customer Approved On",
      customerChanged: "User confirmed that the bundle is in the basket",
      customerChangedToBundle: "Customer Changed Basket to Potential Bundle",
      customerDidNotChange: "User confirmed that the bottle is in the basket",
      customerSelectedItemId: "Customer Selected Item ID",
      guid: "GUID",
      itemId: "Item ID",
      measuredWeight: "Measured Weight",
      notAvailable: "Not Available",
      potentialBundleDetails: "Potential Bundle Details",
      productWeight: "Product weight",
      shortTitle: "BB Check",
      title: "Bottle bundle check",
      weight: "Weight",
      weightChange: "Weight change"
    },
    bottleBundleCheckCount: "Bottle bundle checks",
    bottleBundleCheckDetails: "Bottle Bundle Check Details",
    bottomImagesCount: "# Bottom Images",
    bundle: "Has bundle probability",
    cart: "Cart",
    cartId: "Cart Id",
    chronologicalTimeline: "Chronological Timeline",
    classificationDetectionThreshold: "Classification threshold",
    classificationsCount: "# Classifications",
    compareReceipt: {
      diff: "Difference receipt - {cartBrand}",
      diffAccountedFor: "Accounted for",
      diffRemaining: "Remaining",
      mark: "Possibly scanned a register",
      noDiff: "No difference between {cartBrand} and register",
      title: "Compare with receipt"
    },
    completeAnalysis: "Complete Analysis",
    confirmSuspiciousSessions: "Confirm suspicious sessions",
    customerGuid: "Customer Guid",
    demo: "Demo",
    diffProduct: "Different product",
    dsiAnalysis: "DSI Analysis",
    duration: "Duration",
    expectedWeight: "Expected Weight",
    filterPresets: {
      bundleIrregularity: "Irregularity Crate",
      button: "Filter presets",
      "default": "Default",
      label: "Label images",
      paymentIssues: "Payment problems",
      randomCheck: "Random Checks"
    },
    filtersActive: "Active filters:",
    finish: {
      OK: "Ok",
      abandoned: "Abandoned Purchase",
      blackPicture: "Black picture / camera covered",
      bottomCam: "Bottom camera",
      brokenLogs: "Broken session logs",
      chooseOptionText: "Please choose one of the following options",
      comment: "Comment",
      coveredByBag: "Products covered by bag",
      coveredByChild: "Products covered by child",
      inquiry: "Inquiry",
      irregularity: "Irregularity",
      label: "Finish",
      locked: "Locked",
      mark: {
        addCustomerMark: "Issues have been found. Do you want to mark this customer?",
        addDsiSessionToCustomerMark: "This customer is already marked. Do you want to add the issues found in this session to the mark?",
        removeCustomerMark: "This customer has been marked because of this session. Do you want to remove the mark?",
        replaceDsiSessionInCustomerMark: "This customer is already marked because of a DSI session. Do you want to replace the session with this one?"
      },
      misaligned: "Camera angle misaligned",
      missingLogs: "Missing session logs",
      noPics: "No pictures",
      notEdited: "Not edited",
      notPlacedOnCart: "Products not placed on cart",
      notPlacedOnScale: "Products not placed on scale",
      notReviewableContent: "Not reviewable (contentwise)",
      notReviewableContentReason: {
        abandoned: "Abandoned Purchase",
        coveredByBag: "Products covered by bag",
        coveredByChild: "Products covered by child",
        notPlacedOnCart: "Products not placed on cart",
        notPlacedOnScale: "Products not placed on scale",
        testSession: "Test Session"
      },
      notReviewableTech: "Not reviewable (technically)",
      notReviewableTechReason: {
        blackPicture: "Black picture / camera covered",
        bottomCam: "Bottom camera",
        brokenLogs: "Broken session logs",
        misaligned: "Camera angle misaligned",
        missingLogs: "Missing session logs",
        noPics: "No pictures",
        quality: "Bad picture quality",
        reversed: "Reversed cameras (top - bottom)",
        topCam: "Top camera"
      },
      quality: "Bad picture quality",
      reversed: "Reversed cameras (top - bottom)",
      summary: "Summary of issues",
      testSession: "Test Session",
      topCam: "Top camera"
    },
    freshFoodCounter: "Fresh Food Counter probability",
    genericCoffee: "Generic coffee probability",
    hasManualAnnotations: "Manual Annotations",
    help: {
      annotatingKeys: "Annotating keys",
      annotatingKeysWithoutLabelling: "Annotating keys (with labelling disabled)",
      classificationEmpty: "Set classification to Empty",
      classificationLoaded: "Set classification to Loaded",
      classificationUnsure: "Set classification to Unsure",
      detectionsAcceptAllRemaining: "Accept all remaining detections",
      editBundles: "Start editing bundle sizes",
      enter: [
        "During labelling: Cycle through bundle inputs",
        "In Finish screen: Go to next session"
      ],
      first: "Go to first event",
      firstSession: "Go to first session",
      generalKeys: "General keys",
      labellingKeys: "Labelling keys",
      last: "Go to last event",
      lastSession: "Go to last session",
      next: "Go to next event",
      nextSession: "Go to next session",
      previous: "Go to previous event",
      previousSession: "Go to previous session",
      ratingDetectionCorrect: "Rate detection as Correct",
      ratingDetectionIncorrect: "Rate detection as Incorrect",
      ratingFaulty: "Rate image as Faulty",
      ratingOk: "Rate image as OK",
      ratingUnsure: "Rate image as Unsure",
      selectNthClass: [
        "While no annotation selected: Add annotation with nth class",
        "While annotation selected: Change annotation class to nth class"
      ],
      spaceBar: "Space bar",
      title: "Hotkeys",
      toggleFaulty: "Faulty on/off"
    },
    imageClassBasketCounts: "Basket Counts",
    imageClassDetectionProbabilities: "Detection Probabilities",
    imageViewer: {
      resetCenter: "Re-center",
      resetTransform: "Reset position & scale",
      zoomIn: "Zoom in",
      zoomOut: "Zoom out"
    },
    imagesCount: "# Images",
    inconsistentLabelling: {
      columns: {
        createdOn: "Created on",
        modelId: "Model ID",
        modifiedOn: "Modified on"
      },
      controls: {
        checkbox: {
          boxesInaccurateEdges: "Inaccurate edges",
          boxesMissing: "Missing boxes",
          boxesSurplus: "Too many boxes",
          boxesWrongClass: "Wrong object classes"
        },
        notLabelled: "Not labelled",
        notSupported: "Not supported",
        radio: {
          correctAuto: "Auto boxes (solid) are correct",
          correctHuman: "Human boxes (dashed) are correct",
          correctZeroBoxes: "Zero boxes is correct",
          incorrectBoth: "Both human and auto boxes are incorrect"
        },
        tooltips: {
          checkbox: {
            boxesInaccurateEdges: "One or more boxes have inaccurate edges, i.e. edges inside the object or far away from the outline of the object.",
            boxesMissing: "One or more objects should have boxes, but have none.",
            boxesSurplus: "One or more boxes are present without a corresponding object.",
            boxesWrongClass: "One or more boxes are present in the correct location, but show the wrong type of object."
          },
          radio: {
            correctAuto: "Every automatically generated box (with non-dashed outline) is fully correct & is closer to the real object than the human-generated boxes.",
            correctHuman: "Every human-generated box (with dashed outline) is fully correct & is closer to the real object than the automatically generated boxes.",
            correctZeroBoxes: "There are zero objects in the image that should have boxes, and there are zero human- or auto-generated boxes.",
            incorrectBoth: "There are one or more objects in the image that should have boxes, and both the human- and automatically generated boxes are wrong (please specify below how)."
          }
        }
      },
      help: {
        feedbackKeys: "Feedback keys",
        ratingKeys: "Rating keys",
        setRatingTo: "Set rating to \"{rating}\"",
        toggleFeedback: "Toggle feedback \"{feedback}\""
      },
      noSessionsInQueue: "No sessions found in queue!",
      openQueue: "Open queue ({amount})",
      queueIsEmpty: "Queue is empty"
    },
    inspect: {
      confirm: {
        other: "Other",
        productMissing: "Product is missing",
        productNotMissing: "Product is not missing",
        productScannedAtCashier: "Product was scanned at cashier"
      },
      detectionIsCorrect: "Detection is correct",
      detectionIsIncorrect: "Detection is incorrect",
      faultyImage: "Faulty image",
      inspectAndConfirmForClassName: "Inspect & confirm suspicious sessions for \"{classificationClassName}\"",
      inspectForClassName: "Inspect suspicious sessions for \"{classificationClassName}\"",
      inspection: "DSI Inspection",
      isOneHighlightedItemOfClass: "Is at least one of the highlighted items a \"{classificationClassName}\"?",
      notFound: "Session not found"
    },
    inspectSuspiciousSessions: "Inspect suspicious sessions",
    inspection: "Inspection",
    inspectionConfirmation: "Insp. Confirmation",
    isFullyAnnotated: "Fully Annotated",
    jackDaniels: "Jack Daniels probability",
    labelCount: "Label Count",
    labelling: {
      addClassifier: "Add classifier",
      additionalAnnotations: "Additional Annotations",
      amount: "Amount",
      annotations: {
        annotationDelete: "Delete wrong annotation",
        annotationEdit: "Edit annotation position",
        annotationEditCancel: "Cancel editing",
        annotationEditConfirm: "Confirm new position",
        classIsDisabled: "This class has been disabled and can no longer be used.",
        copyPrevious: "Copy previous annotations",
        copyPreviousDisabledBecauseAnnotationsExist: "Annotations can't be copied while additional annotations have already been created",
        copyPreviousDisabledBecausePreviousHasNone: "Annotations can't be copied if the previous step has none",
        detectionDelete: "Delete wrong detection",
        detectionEdit: "Edit detection position",
        detectionEditCancel: "Cancel editing",
        detectionEditConfirm: "Confirm new position",
        detectionIsCorrect: "Detection is correct",
        downloadManual: "Download DSI Annotation manual (PDF)",
        drawBoundingBox: "Draw bounding box for class: {annotationClass}",
        sectionAnnotationsDisabledExplanation: "All recognized classifiers have to be processed first (either accepted, modified or deleted)",
        sectionDetectionsDisabledExplanation: "The image has to be rated first (upper right)",
        sectionDisabledBecauseOfImageRatingExplanation: "The image wasn't rated as OK"
      },
      applyToNext: "Apply values for next",
      articles: "Items",
      articlesPerBundle: "Items per bundle",
      bundles: "Bundles",
      classification: {
        empty: "Empty",
        loaded: "Loaded",
        unsure: "Unsure"
      },
      empty: "Empty",
      faulty: "Faulty",
      faultyTooltip: "The photo wasn't taken correctly (e.g. camera was blocked, camera is broken)",
      general: "General",
      hotkey: "Hotkey",
      labellingBundles: {
        bundle: "Items per bundle",
        noBundle: "No bundle",
        unsure: "Unsure"
      },
      labellingLoaded: {
        empty: "Empty",
        faulty: "Faulty",
        loaded: "Loaded",
        unsure: "Unsure"
      },
      noAdditionalAnnotations: "No additional annotations added",
      noClassifiersDetected: "No classifiers detected",
      okTooltip: "The photo was taken correctly and you're not unsure about any object classes",
      recognizedClassifiers: "Recognized Classifiers",
      reset: "Reset this image classification",
      resetAnnotations: "Reset Annotations",
      resetAreYouSure: "Are you sure you want to reset this image classification?",
      settings: "Settings",
      unsure: "Unsure",
      unsureTooltip: "You are unsure about one or more of the object classes in the photo"
    },
    live: {
      classifier: "Classifier",
      detectionWasConfirmedBy: "Detection was confirmed by",
      enableCardSwipe: "Enable card swipe",
      enableManualCheckForCustomer: "Do you want to enable manual check for this customer?",
      isThisItemOfClass: [
        "Is this a",
        "{classificationClassName}",
        "?"
      ],
      lastDetectionTimestamp: "Last detection timestamp",
      lastUpdatedMinutesAgo: "{minutes} minutes ago",
      loadNewSnapshot: "Load new snapshot",
      newerDetectionReceivedForClass: [
        "Newer detection received for:",
        "{classificationClassName}",
        ""
      ],
      noSessionData: "No session data available - either all detections have associated products in basket, or session was closed",
      noSessions: "Currently no session matches the selected filters.",
      noUnconfirmedDetectionsLeftForSession: "No unconfirmed detections left for this session",
      notifications: {
        subscribe: "Subscribe",
        title: "New detection in store: {store}",
        unsubscribe: "Unsubscribe"
      },
      openInSessionHistory: "Try to open in session history",
      returnToLiveSessions: "Return to live session overview",
      sessionAlreadyClosed: "Session is already closed or does not exist",
      subscriptions: {
        explanation: "Notify me for suspicious sessions in the following stores",
        title: "Store Subscriptions"
      }
    },
    loaded: "Is loaded probability",
    lock: {
      aquiring: "Aquiring lock...",
      forceLock: "Override lock",
      forceUnlock: "Force unlock",
      locked: "Locked"
    },
    login: {
      customerCard: "Customer Card",
      customerCardNumber: "Card Number",
      customerCardType: {
        "carrefourRo.AFG": "Carrefour RO AFG"
      },
      loginType: "Login type"
    },
    markReason: {
      dsi: "DSI",
      dsiIrregularities: "Irregularities",
      label: "Mark Reason",
      randomCheck: "Random Check"
    },
    markSessionOn: "Mark Session on",
    markedOn: "Marked on",
    market: "Store",
    maxTimeExpired: "Query took too long. Please apply stricter filters.",
    moreSessions: "There are more sessions. Try using more specific filters...",
    multiSessionTicket: {
      title: "Multiple logins on same day"
    },
    nextSession: "Next Session",
    noSessionData: "No session data available",
    noSessions: "No session matches the selected filters.",
    notScanned: "Product not scanned",
    optionSections: {
      bottomCartlabeling: "Labelling: Bottom Cart",
      topCartAnnotating: "Annotating: Top Cart"
    },
    payment: "Payment",
    paymentMethod: "Payment Method",
    paymentRequest: {
      status: "Status",
      title: "Payment Request",
      total: "Total"
    },
    paymentStatus: {
      notPaid: "Not paid",
      paid: "Successfully paid",
      title: "Payment Status"
    },
    price: "Price",
    probabilityThreshold: "Probability Threshold",
    productSearch: {
      free: "Free text",
      groups: "Product groups",
      products: "Products",
      select: "Select a product group or start typing to search..."
    },
    randomCheck: {
      cancelReason: "Cancel Reason",
      cancelReasons: {
        "payment-cancelled": "Payment Cancelled"
      },
      checkedOn: "Random Check Time",
      itemsToVerify: "Items to Verify",
      noData: "No Data",
      noItemsWereScanned: "No Items Were Scanned",
      scannedItems: "Scanned Items",
      source: "Source",
      sources: {
        CUSTOMER_MARK: "Customer Mark",
        IMAGE_DETECTION: "Image Detection",
        MULTIPLE_SESSIONS_PER_DAY: "Multiple Sessions Per Day",
        RANDOM: "Random",
        REMOVED_PRODUCTS: "Removed Products",
        RISK_AREA: "Risk Zone",
        SCANNED_PRODUCTS: "Scanned Products",
        SESSION_MONITOR: "Session Monitor",
        SYSTEM_CUSTOMER_MARK: "Customer Mark (System)",
        WEIGHT_WITHOUT_SCAN: "Weight Without Scan"
      },
      status: {
        Cancelled: "Cancelled",
        Failed: "Failed",
        FailedContinued: "Failed, but Continued",
        ImageDetectionsWrong: "Image Detection Wrong",
        PaymentCancelled: "Payment Cancelled",
        Pending: "Pending",
        PendingNotStarted: "Not Started",
        PendingStarted: "Started, not Finished",
        Succeeded: "Succeeded",
        none: "Not Required"
      },
      title: "Random Check",
      wasSelectedRandomly: "Selected Randomly"
    },
    removed: "Subsequently removed",
    saveAndClose: "Save & Close",
    saveAndNext: "Save & Next",
    sessionEnd: {
      closedBy: "Closed by",
      closedBySource: {
        LogoutDeclinedLegal: "Legal terms declined",
        LogoutInactiveSessionsJob: "Inactivity timeout",
        cashier: "Cashier terminal",
        cashierPaymentCompleteNotification: "Cashier (notification)",
        easyPay: "Pay by App",
        edekaApp: "EDEKA App",
        hiddenMenu: "Staff, via cart menu",
        logoutButton: "Customer logged out",
        manualOverride: "Manual override",
        newCustomerLogin: "Next customer logged in",
        pos: "POS",
        scheduler: "Scheduled maintenance"
      },
      noPaymentRequest: "No payment attempted",
      reasons: {
        demo: "Demo",
        noCustomerPresent: "No customer present",
        other: "Other",
        paymentProblems: "Payment problems",
        purchaseDoesNotCloseAfterPayment: "Purchase did not close",
        technicalProblems: "Technical problems",
        testing: "Testing",
        theft: "Deviation after smart check"
      },
      title: "End of Session"
    },
    sessionGuid: "Session Guid",
    snapshot: "Snapshot",
    sosTicket: {
      reason: "Reason",
      status: "Status",
      title: "SOS Ticket"
    },
    startEnd: "Start/ End",
    startOfSession: "Start of Session",
    startOfSessionAtCart: "Start of Session @ Cart {cartId}",
    status: "Status",
    switchBundle: "Bundle Switch",
    unknownBarcode: {
      code: "Code",
      count: "Count",
      product: "Unknown Barcode Product",
      title: "Unknown Barcode",
      type: "Type",
      unwanted: "Unwanted",
      wanted: "Wanted"
    },
    verificationItem: {
      approved: "Approved",
      discountedAmount: "Discounted Amount",
      notApproved: "Not Approved",
      optional: "Optional",
      properties: {
        age: "Age",
        codeType: "Code Type",
        itemCount: "Item Count",
        itemsToPickup: "Items to pick up",
        type: "Type"
      },
      referenceBasketItems: "Reference Basket Items",
      required: "Required",
      type: {
        AgeType: "Age Check",
        BarcodeClassificationVerificationMessage: "Barcode Classification Verification",
        CheckForEmptyCrate: "Check for empty crate",
        CollectCoupon: "Collect Coupon",
        CollectDepositReturnSlip: "Bottle return receipt",
        DiscountedItems: "Discounted Items",
        InformCustomerToPickupGoods: "Pickup",
        MultipleCodesToBeScanned: "Multiple Codes",
        RemovedProductsVerification: "Removed Products",
        UnknownBarcode: "Unknown Barcodes (Removed)",
        WantedUnknownBarcode: "Unknown Barcodes (Kept)",
        WeightWithoutScan: "Weight Without Scan"
      },
      verificationItem: "Verification Item"
    },
    weightDeviation: "Weight Deviation",
    weightWithoutScan: {
      alerts: "Weight Without Scan Alerts",
      customerConfirmation: "Customer Confirmation",
      options: {
        barcodeArticle: "Barcode Product",
        no: "Nothing was added",
        other: "Other",
        personalItem: "Personal Item",
        pluArticle: "{cartBrand} No.",
        pluHierarchy: "Item without a barcode"
      },
      title: "Weight Without Scan"
    },
    wrongQuantity: "Wrong quantity"
  },
  edit: "Edit",
  erp: {
    assets: {
      actions: {
        editAsset: "Edit asset",
        moveAsset: "Move asset",
        moveToLocation: "Move asset to new location",
        showDetails: "Show details"
      },
      move: {
        currentLocation: "Current location",
        moveAssetFrom: "Move {type} \"{name}\" from location:",
        newLocation: "New location",
        toNewLocation: "To new location:"
      },
      noResults: "No assets found.",
      simpleDetails: {
        notFound: "Asset not found",
        title: "Asset:"
      },
      title: "Assets"
    },
    codes: {
      addNewPropertyId: "Add new property ID",
      navTitle: "Codes",
      propertyId: "Property ID",
      propertyValue: "Property value",
      title: "Resource Planner: Codes",
      titleAddNew: "Resource Planner: Add new code",
      titleEdit: "Resource Planner: Edit code"
    },
    edit: "Edit",
    locations: {
      "delete": {
        areYouSure: "Are you sure you want to delete location \"{name}\" of type \"{type}\"?",
        title: "Delete location?"
      },
      edit: {
        title: "Edit location"
      },
      fields: {
        address: {
          city: "City",
          country: "Country",
          line2: "Address line 2",
          section: "Address",
          streetNr: "Street nr.",
          zipCode: "Zip Code"
        },
        id: "ID",
        name: "Name",
        type: "Type"
      },
      location: "Location",
      title: "Locations",
      types: {
        "delete": {
          areYouSure: "Are you sure you want to delete location type \"{name}\"?",
          title: "Delete location type?"
        },
        edit: {
          title: "Edit location type"
        },
        fields: {
          id: "ID",
          name: "Name"
        },
        manage: "Manage location types",
        noTypesFound: "No location types found.",
        title: "Location types"
      }
    },
    newEntryFilters: "Entry for new Carts or Charging Options is not visible when filters are set",
    plan: {
      confirmChangePast: {
        "delete": {
          message: "Be aware that this could impact past invoices!",
          title: "Delete entry in the past?"
        },
        edit: {
          message: "Be aware that this could impact past invoices!",
          title: "Edit entry in the past?"
        },
        restore: {
          message: "Be aware that this could impact past invoices!",
          title: "Restore entry in the past?"
        }
      },
      deletedItem: "Item is marked for deletion",
      fieldValues: {
        action: {
          add: "Add",
          fromStorage: "From Storage",
          remove: "Remove",
          toStorage: "To Storage"
        },
        type: {
          cart: "Cart",
          chargingOption: "Charging Option"
        }
      },
      fields: {
        action: "Action",
        amount: "Amount",
        change: "Change",
        comment: "Comment",
        effectiveOn: "Effective on/Installed on",
        id: "Id",
        invoicedFrom: "Invoiced from",
        location: "Location",
        rentUntil: "Rent until",
        storeGuid: "Storeguid",
        storeName: "Store",
        subType: "Sub Type",
        tariff_capacity: "Tariff/Capacity",
        type: "Type",
        version_connector: "Version/Connector"
      },
      filters: {
        cart: "Carts",
        chargingOption: "Charging Options",
        deleted: "Show deleted entries"
      },
      navigation: "Planner",
      noMatchingItems: "No matching items found.",
      rowActions: {
        history: "History",
        snapshot: "View Snapshot"
      },
      title: "Planner for {store}",
      titleGlobal: "Planner for all stores"
    },
    planSummary: {
      location: {
        storage: "In Storage",
        store: "In Store"
      },
      title: {
        cart: "Carts",
        chargingOption: "Charging Options"
      }
    },
    properties: {
      amount: {
        title: "Amount"
      },
      cart_tariff: {
        title: "Tariff"
      },
      cart_type: {
        title: "Type",
        values: {
          light: "Light",
          premium: "Premium"
        }
      },
      cart_version: {
        title: "Version"
      },
      chargingOption_capacity: {
        title: "Capacity"
      },
      chargingOption_connector: {
        title: "Charging connector",
        values: {
          plugLight: "Light Plug",
          plugPremium: "Premium Plug",
          rail: "Charging rail"
        }
      },
      chargingOption_type: {
        title: "Type",
        values: {
          chargingBox: "Charging box (Outside)",
          chargingStation: "Charging station (Inside)",
          mobileChargingStation: "Mobile charging station (Pentland)",
          mobileChargingUnit: "Mobile charging unit (Extern)"
        }
      },
      location: {
        title: "Location"
      }
    },
    props: {
      confirmDelete: {
        message: "Are you sure you want to delete the \"{property}\" property?",
        title: "Delete Property?"
      },
      edit: {
        condition: "Condition",
        conditionKey: "Key",
        conditionValue: "Value",
        title: "Edit Property",
        unique: "That value is already used",
        valueRequired: "At least one value is required"
      },
      fields: {
        description: "Description",
        id: "Id",
        values: "Values"
      },
      title: "Properties"
    },
    title: "Resource Planner"
  },
  error: {
    backToStart: "Back to homepage",
    code: "Code {code} could not be rendered",
    reload: "Reload page",
    showDetails: "Show details",
    title: "Error",
    uncaught: "An error has occurred."
  },
  events: {
    canNotDeleteCategory: "This category cannot be deleted because it is used in one or more events.",
    canNotDeleteSubcategory: "This subcategory cannot be deleted because it is used in one or more events.",
    categories: "Categories",
    deleteCategory: "Delete Category",
    deleteEntry: "Delete Entry",
    deleteEvent: "Delete Event",
    editCategory: "Edit Category",
    events: "Events",
    newCategory: "New Category",
    noReverseAction: "This action cannot be reversed",
    subcategoryAlreadyExists: "This subcategory already exists in this category.",
    table: {
      addNewCategory: "Add new category",
      addNewEvent: "Add new event",
      category: "Category",
      comment: "Comment",
      createdOn: "Created on",
      date: "Date",
      id: "ID",
      modifiedOn: "Modified on",
      name: "Name",
      store: "Store",
      subcategories: "Subcategories",
      subcategory: "Subcategory"
    },
    title: "Store Events"
  },
  execute: "Execute",
  expand: "Show more",
  failed: "Failed",
  fields: {
    target: "Target",
    validity: "Validity"
  },
  global: "Global",
  globalCartTable: {
    columns: {
      cartGuid: "Cart GUID",
      cartId: "Cart ID",
      cartType: "Type",
      changedBy: "Changed By",
      createdOn: "Created On",
      currentEnvironment: "Current Environment",
      details: "Details",
      framenumber: "Frame Number",
      hostname: "Hostname",
      isDisabled: "Is Disabled",
      isGpsDisabled: "Is GPS Disabled",
      modifiedOn: "Modified On",
      productNumber: "Product Number",
      reachable: "Reachable",
      scaleCalibration: "Scale Calibration",
      storeName: "Store Name"
    },
    details: {
      linkToStore: "View Cart Store Details",
      title: "Global Cart Details"
    },
    title: "Global Carts"
  },
  go: "Go",
  history: {
    action: "Action",
    added: "Added",
    changed: "Changed",
    changes: "Changes",
    group: "Group",
    modifiedBy: "User",
    modifiedOn: "Time",
    title: "History"
  },
  imageClassification: {
    aptamil: "Aptamil",
    ariel: "Ariel",
    cart: "Cart",
    cigarettes: "Cigarettes",
    cloud: "Cloud",
    fresh_food_counter: "Fresh Food Counter product",
    generic_coffee: "Generic coffee",
    head_and_shoulders: "Head & Shoulders",
    jack_daniels: "Jack Daniels",
    merci: "Merci",
    nescafe: "Nescafé",
    produce_net: "Produce Net",
    product: "Product",
    razorblades: "Razor Blades",
    redbull: "Red Bull",
    toffifee: "Toffifee"
  },
  imageClassifier: {
    actions: "Actions",
    coverage: {
      allStores: "All Stores",
      ambiguous: "Conflicting cloud candidates — Selection unknown",
      cloudScope: "Cloud-wide, regardless of store scope",
      disabled: "Disabled — Environment not enabled",
      disclaimer: "Configuration preview only — not live runtime status. Downloads, loaded models, camera compatibility and inference settings are not checked. Cloud selection ignores store targeting.",
      equalPriority: "Scope priority, modification time and MD5 are identical. Like the Go watcher, the first candidate is retained. Live database order may differ from this inventory.",
      hashWins: "With equal scope priority and modification time, the lexicographically greater MD5 wins.",
      inventory: "Technical view",
      missing: "Missing — No model targets this store",
      modelsError: "Classifier configuration could not be loaded. Preview is unavailable.",
      newerWins: "With the same scope priority, the model modified more recently wins.",
      noResults: "No networks in the model inventory.",
      onlyEligible: "Only one enabled model applies to this execution environment and store.",
      outOfScope: "Not assigned to this store",
      overridden: "Overridden by a higher-priority model",
      preferredModel: "Preferred candidate: {fileName}",
      selected: "Selected",
      storeOverride: "Store-specific override",
      storeSpecificWins: "The store-specific model takes priority over the global model, even if the global model was modified more recently.",
      tooLarge: "Blocked — exceeds cart model size limit"
    },
    deleteImageClassifier: "Delete Image Classifier",
    disabledModel: "Disabled",
    editImageClassifier: "Edit Image Classifier",
    messages: {
      deletedSuccessfully: "Image classifier deleted successfully",
      downloadedSuccessfully: "Image classifier downloaded successfully",
      editUploadedAssignment: "The file \"{fileName}\" was stored, but the selected model type and store assignment could not be saved. Edit this model in Technical view to set its assignment; you do not need to upload the file again.",
      errorDeleting: "Error deleting image classifier",
      errorDownloading: "Error downloading image classifier",
      errorUpdating: "Error updating image classifier",
      errorUploading: "Error uploading image classifier",
      unknownError: "Unknown error",
      updatedSuccessfully: "Image classifier updated successfully",
      uploadedSuccessfully: "Image classifier uploaded successfully"
    },
    table: {
      blobPath: "Blob Path",
      cdnRelativePath: "CDN Relative Path",
      createdBy: "Created By",
      createdOn: "Created On",
      deletedBy: "Deleted By",
      environments: "Environments",
      fileName: "File Name",
      fileSize: "File Size",
      id: "ID",
      md5Hash: "MD5 Hash",
      modifiedBy: "Modified By",
      modifiedOn: "Modified On",
      network: "Network",
      stores: "Stores"
    },
    title: "Image Classifiers",
    uploadImageClassifier: "Upload Image Classifier",
    uploadModelFileRequired: "Choose an ONNX or PB model file before uploading.",
    uploadNetwork: "Network contained in the uploaded model",
    workflow: {
      assignStores: "Assign to stores",
      conflictsLabel: "Conflicts",
      defaultAction: "Make {environment} default",
      duplicateFilename: "A model with this filename already exists.",
      fileLabel: "File",
      filenameSuggestion: "Suggestion: '<MODEL_TYPE>_<SPRINT_NR>.onnx'",
      inactive: "Inactive",
      noEnabledModel: "No model enabled",
      removeOverride: "Remove store override",
      selectStores: "Select at least one store.",
      selectedStores: "Selected stores",
      showDisabled: "Show disabled models ({count})",
      sizeRequired: "Cart assignment requires a known file size and size limit.",
      staleModel: "This model is unavailable or already changed. Close and refresh.",
      storage: "Storage",
      storeConflict: "These stores already have a Cart override for this network. Unassign them from their current model first.",
      storesUnavailable: "Store names are unavailable. Wait or refresh.",
      uploadModelTitle: "Upload {modelType}"
    }
  },
  information: {
    addNew: "Add new info material",
    addNewIsDisabledInStoreContext: "Adding new info materials is disabled in the store context. Please switch to the global view to add new info materials.",
    cancelEditingOrder: "Cancel editing order",
    editOrder: "Edit order of info materials",
    editOrderIsDisabledInStoreContext: "Editing the order of info materials is disabled in the store context. Please switch to the global view to edit the order.",
    form: {
      appliesToStores: "Applies to stores",
      changesSaved: "Changes have been saved",
      chooseFile: "Choose file...",
      confirmDelete: "Are you sure you want to delete info material \"{name}\"?",
      "delete": "Delete info material",
      emptyTitleUsesMainLanguageTitle: "If left empty, uses main language title",
      fileTooLargeMessage: "Info materials may at most be {limit} KB large, but your selected file has {size} KB (+{delta} KB).\nPlease choose a different file.",
      fileTooLargeTitle: "Selected file \"{name}\" is too large",
      fileWithName: "File: {name}",
      languagesTable: {
        document: "Document",
        language: "Language",
        title: "Title"
      },
      mainLanguage: "Main language",
      titleEdit: "Edit existing info material \"{name}\"",
      titleNew: "Add new info material",
      validations: {
        mainLanguageRequired: "The info material must have a valid title and document for the main language."
      }
    },
    saveNewOrder: "Save new order",
    storeType: {
      all: "All stores",
      light: "Light & mixed stores only",
      mixed: "Mixed stores only",
      premium: "Premium & mixed stores only"
    },
    title: "Information"
  },
  input: {
    checkAgainstCurrent: "Always checks against current dev/test/latest!",
    noOptionsMessage: "No options",
    select: "Select.."
  },
  integrityChecks: {
    canceled: "canceled",
    completed: "completed",
    failed: "failed",
    noResults: "No pending Random Checks.",
    pending: "pending"
  },
  inventoryManagementSystem: {
    "1": "EBUS",
    "2": "RWWS",
    "5": "REDDI"
  },
  keys: {
    alt: "Alt",
    control: "Control",
    "delete": "Delete",
    enter: "Enter",
    escape: "Escape",
    left: "Left click",
    leftright: "Left/right click",
    middle: "Mouse wheel",
    numberKeys: "Number keys",
    pageDown: "Page down",
    pageUp: "Page up",
    right: "Right click",
    shift: "Shift"
  },
  latestUpdate: "Latest update: {date}",
  layerSelection: {
    affectedStores: "Affected Stores",
    allBranches: "All retail formats",
    allCompanies: "All companies",
    allIms: "All Inventory Management Systems",
    allStores: "All stores",
    allTenants: "All clients",
    exclude: {
      branches: "Not in these retail formats",
      companies: "Not in these companies",
      fallback: "exclude",
      ims: "Not in these Inventory Management Systems",
      stores: "Not in These Stores",
      tenants: "Not for these clients"
    },
    include: {
      branches: "Only in these retail formats",
      companies: "Only in these companies",
      fallback: "include",
      ims: "Only in these Inventory Management Systems",
      stores: "Only in These Stores",
      tenants: "Only for these clients"
    },
    layer: "Layer"
  },
  loading: "Loading...",
  loadingModule: "Loading module...",
  loginType: {
    anonymous: "Anonymous Login",
    appLogin: "App Login",
    customerCardLogin: "Customer Card Login",
    demoLogin: "Demo Login",
    edekaApp: "EDEKA App Login",
    externalApp: "External App Login",
    hwo: "HWO Demo Login",
    marktkaufApp: "Marktkauf App Login"
  },
  maintenanceModes: {
    active: "Active",
    inactive: "Inactive",
    maintenance: "Maintenance",
    repaired: "Repaired"
  },
  mapEditor: {
    actions: {
      "delete": "Delete map",
      editData: "Edit data",
      editMap: "Setup map",
      editObjects: "Edit map areas/points",
      editShelves: "Measure shelves",
      editTiles: "Tune navigation",
      waitForMap: "Map needs to be set up first"
    },
    add: "Add new map",
    areas: "Areas",
    chooseFile: "Choose a file",
    configureLevels: "Configure store maps",
    data: {
      title: "Edit map data ({level})",
      titleNew: "Create new map"
    },
    editObjects: "Edit objects",
    editOffset: "Edit offset",
    editTiles: "Edit tiles",
    errors: {
      invalidGrouping: "Id does not exist",
      minLessMax: "min must be less than max",
      required: "Required",
      systemIdTaken: "Id Already taken"
    },
    groupWithSystemId: "Grouped Id",
    groupWithSystemIdHelp: "(Optional) Reference another system Id to render both maps in the same plane. This only works if they exist in the same coordinate system but have to use multiple navigation systems for some reason.",
    mapBounds: "Map Bounds",
    mapFile: "Map File",
    mapSetup: {
      addAnchor: "Add anchor",
      anchors: "Anchors",
      coordinate: "Real world coordinate (m)",
      name: "Name",
      noAnchors: "There are no anchors yet, so a default scale will be used. This is fine for stores that don't have navigation. For stores with navigation anchors have to be set!",
      quickHelp: [
        "Place anchors on the map image and enter their real world coordinates. The map bounds will be calculated automatically.",
        "You should add at least 2 anchors that differ significantly in x and y direction. More are better to minimize errors."
      ],
      rotate: "Rotate map ({rotation}°)",
      showGrid: "Show grid",
      showTiles: "Show tiles",
      title: "Setup map ({level})"
    },
    name: "Name",
    objects: {
      addAreaPolygon: "Add area (polygon)",
      addAreaRect: "Add area (rectangle)",
      addPoi: "Add point of interest",
      addPortal: "Add portal",
      areas: "Store areas",
      commodityGroups: "Product categories",
      customIcons: {
        noneFound: "No custom icons defined in branding: {branding}",
        source: "Custom icon source:"
      },
      distance: "Distance",
      editTextBounds: "Edit text bounds",
      flags: {
        bakeryArea: "Bakery Area",
        checkout: "Checkout",
        drinkArea: "Drink Area",
        fruitOrVeggieArea: "Fruits or Vegetables Area",
        outside: "Outside of the sales area",
        paymentArea: "Payment Area",
        riskArea: "Risk Area"
      },
      flagsSection: "Properties",
      help: {
        editObjects: "Edit objects by dragging points, lines and areas",
        invertSnap: "Invert snap setting",
        pan: "Move map",
        splitLines: "Adds a point to split a line or removes a point to merge two lines",
        title: "Help"
      },
      icon: "Icon",
      inaccessible: "Inaccessible",
      name: "Name",
      poi: "Points Of Interest",
      portals: "Transitions",
      portalsTo: "Transitions to",
      quickHelp: [
        "Define store area, points of interest and transitions between maps.",
        "They will be displayed on the cart map while using the product navigation."
      ],
      resetTextBounds: "Reset text bounds",
      riskZone: {
        apply: "Apply",
        commodityGroupsFailed: "Product categories could not be loaded.",
        duration: "{minutes} min {seconds} s",
        durationMinutesOnly: "{minutes} min",
        dwellTime: "Dwell time",
        dwellTimeHelp: "A basket check is suggested when a customer stays longer than this without taking anything from the selected product categories. Seconds are optional.",
        edit: "Edit",
        incomplete: "This risk zone is not evaluated until a dwell time and at least one product category are set.",
        minutes: "Minutes",
        notSet: "Not set",
        seconds: "Seconds",
        title: "Risk zone"
      },
      snap: "Snap to points and lines",
      title: "Edit store objects ({level})"
    },
    orDropIt: "Or drop it",
    pleaseSelect: "Choose a file, paste it or drag it here",
    poi: "POI",
    portals: "Transitions",
    removeConfirmation: "Are you sure you want to delete map {level}?",
    settings: {
      options: {
        isSpecialityMarketEnabled: "Speciality store enabled",
        isSpecialityMarketEnabledTooltip: "If enabled, a range of shelves can be marked as being in a speciality store. When choosing an item in such a shelf for navigation, a messag will be displayed to the user.",
        sosMapEnabled: "SOS map enabled",
        sosMapEnabledTooltip: "Enables the fallback store map for customers in the help dialog. If enabled and the cart has no position (no navigation or broken navigation), the map will be shown so that the customers can pick their location. If disabled, the sos map is never shown.",
        specialityMarketShelfNoLowerEnd: "From shelf number",
        specialityMarketShelfNoUpperEnd: "To shelf number",
        subTitle: "Tweak the navigation experience on the cart.",
        title: "Navigation options"
      },
      status: {
        active1: "On",
        active2: "Available for customers",
        internal1: "Internal",
        internal2: "Services are installed but feature is hidden. Enable for testing in the {cartBrand}'s admin menu.",
        off1: "Off",
        off2: "No navigation installed",
        on1: "On",
        on2: "Available for customers",
        subTitle: "Choose whether navigation should be enabled on the carts. When switching to or from \"Off\", changes are applied only after redeployment.",
        title: "Navigation status"
      }
    },
    shelves: {
      cgLongIdCount: "{count, plural, one { # entry } other { # entries }}",
      col: {
        commodityGroupLongIds: "cgLongIds",
        createdOn: "Created On",
        measurementType: "Measurement Type",
        modifiedOn: "Modified On",
        shelf: "Shelf",
        shelfGuid: "shelfGuid",
        shelfId: "Shelf Id",
        shelfNo: "Shelf No."
      },
      commodityGroupLongIds: "Product Categories",
      editShelfId: "Shelf {shelfId}"
    },
    systemId: "System Id",
    systemIdHelp: "Has to be the same Id that the navigation system emits on that level.",
    tiles: {
      accuracy: {
        all: "All",
        label: "Accuracy"
      },
      cart: "Place cart for route calculation",
      "delete": "Delete all manual tiles",
      free: "Freehand drawing tool",
      help: {
        allow: "Allow tile",
        allowed: "Manually allowed",
        auto: "Calculated from carts",
        block: "Block tile",
        blocked: "Manually blocked",
        control: "Control",
        left: "Left click",
        leftright: "Left/right click",
        middle: "Mouse wheel",
        pan: "Move map",
        rect: "Draw rectangles",
        redo: "Redo",
        revert: "Revert tile to automatic value",
        right: "Right click",
        shift: "Shift",
        title: "Help",
        undo: "Undo"
      },
      missingBounds: "Missing map bounds",
      missingFile: "Missing map file",
      missingLevel: "Missing map data",
      noRouteFound: "No route found",
      noTilesYet: "No tiles have been calculated yet. Please wait until carts start sending data...",
      rect: "Rectangle drawing tool",
      redo: "Redo",
      reset: "Reset all overrides",
      save: "Save",
      showAccuracyHeatmap: "Show accuracy heatmap",
      showGrid: "Show grid",
      showHeatmap: "Show heatmap",
      showPathPlanningEdges: "Show path planning edges",
      showPathPlanningNodes: "Show path planning nodes",
      showRaw: "Show raw data",
      target: "Place target for route calculation",
      threshold: "Threshold",
      title: "Edit accessible tiles ({level})",
      undo: "Undo"
    }
  },
  marketing: {
    reports: {
      noReports: "No reports available.",
      showDetails: "Show Details",
      table: {
        advertisementGuid: {
          title: "Advertisement GUID"
        },
        averageDuration: {
          title: "Average Duration"
        },
        averageDurationClosed: {
          title: "Average Duration Closed"
        },
        averageDurationSeen: {
          title: "Average Duration Seen"
        },
        campaignId: {
          title: "Campaign ID"
        },
        campaignName: {
          title: "Campaign Name"
        },
        duration: {
          title: "Duration"
        },
        durationClosed: {
          title: "Duration Closed"
        },
        durationSeen: {
          title: "Duration Seen"
        },
        endDate: {
          title: "End Date"
        },
        issuer: {
          title: "Organization"
        },
        mediaUrl: {
          title: "Media URL"
        },
        name: {
          title: "Name"
        },
        numberOfCarts: {
          title: "Number of Carts"
        },
        numberOfClosed: {
          title: "Number of Closed"
        },
        numberOfSeen: {
          title: "Number of Seen"
        },
        numberOfSessions: {
          title: "Number of Sessions"
        },
        numberOfSlots: {
          title: "Number of Slots"
        },
        numberOfStores: {
          title: "Number of Stores"
        },
        slots: {
          title: "Slots"
        },
        startDate: {
          title: "Start Date"
        },
        stores: {
          title: "Stores"
        },
        time: {
          day: "{value, plural, one {# day} other {# days}}",
          hour: "{value, plural, one {# hour} other {# hours}}",
          minute: "{value, plural, one {# minute} other {# minutes}}",
          month: "{value, plural, one {# month} other {# months}}",
          second: "{value, plural, one {# second} other {# seconds}}",
          year: "{value, plural, one {# year} other {# years}}"
        }
      },
      title: "Marketing reports"
    },
    store: "Store"
  },
  marketingPlatform: {
    advertisement: {
      approvedBy: "Approved by",
      approvedOn: "Approved on",
      cancelApprovalRequest: "Cancel approval request",
      cancelUpdateAdvertisementSubmittedForApproval: "No, discard all changes",
      edit: {
        addSlot: "Add Slot",
        blockedLegend: "Occupied by another advertisement",
        chooseFile: "Select file",
        createdBy: "Created: {date} | {user}",
        error: {
          fileSize: "File too big: {current, number} MB > {limit, number} MB",
          noFile: "No file.",
          typeNotSupported: "File type not supported: {type}"
        },
        lastChanged: "Last modified: {date} | {user}",
        orDropHere: "(Or drag it here)"
      },
      meta: "Meta",
      noAccess: "You don't have access to this page.",
      publish: "Publish",
      publishDialog: {
        message: "Once published it will be visible to customers.",
        publish: "Publish",
        title: "Publish Advertisement?"
      },
      publishedMessage: {
        approved: "Advertisement approved and published.",
        notVisible: "Its schedule has no time left in which customers would see it.",
        published: "Advertisement published.",
        visibleFrom: "Customers will start seeing it from {date}.",
        visibleSoon: "Customers will start seeing it within the next few minutes."
      },
      publishedStateInfo: {
        ended: "(Ended)",
        endedOn: "Ended on: {date}",
        notStarted: "(Not started yet)",
        older: "An older version of this advertisement has been published. Submit the current version for approval to replace it.",
        publishedOn: "Published on: {date}",
        startsOn: "Will start on: {date}",
        title: "Advertisement has been published"
      },
      review: {
        approveAdvertisement: "Approve advertisement",
        approveDialog: {
          description: "After approving this advertisement, it will be published and visible to customers.",
          title: "Approve advertisement?"
        },
        changeReviewToApproved: "Change review to Approved",
        changeReviewToRejected: "Change review to Rejected",
        rejectAdvertisement: "Reject advertisement",
        rejectDialog: {
          description: "Please write a short comment explaining why you are rejecting this advertisement, and (if applicable) what changes the submitter has to make before trying again:",
          placeholder: "Comment explaining rejection:",
          title: "Reject advertisement: \"{name}\""
        },
        rejectedMessage: "Advertisement rejected and returned to its creator.",
        requestedBy: "Requested by",
        result: {
          approved: "Approved",
          rejected: "Rejected"
        },
        review: "Review",
        reviewResult: "Review result",
        reviewedBy: "Reviewed by",
        reviewedOn: "Reviewed on",
        reviewerComment: "Comment",
        timestamp: {
          durationAgo: "{duration} ago",
          firstSubmittedOn: "First submitted on",
          justNow: "just now",
          lastModifiedOn: "Last modified on",
          requestSubmittedOn: "Request submitted on"
        },
        title: "Review advertisement approval request",
        updateRejectionComment: "Update rejection comment"
      },
      save: "Save as advertisement",
      saveAsDraftFirst: "Save the advertisement as a draft first.",
      saveChangesFirst: "Save your changes first.",
      slots: {
        after_login: "After Login",
        after_payment: "After Payment",
        before_login: "Before Login",
        before_payment: "Before Payment",
        during_payment: "During Payment",
        on_commodity_group: "In a Product Category"
      },
      submitDialog: {
        message: "Once approved it will be published and visible to customers. You will not be able to make any further changes during the approval process but you can cancel the approval request at any time.",
        submit: "Submit for Approval",
        title: "Submit advertisement for approval?"
      },
      submitForApproval: "Submit for Approval",
      submittedMessage: "Advertisement submitted for approval.",
      unpublish: "Unpublish Advertisement",
      updateAdvertisementSubmittedForApproval: "Yes, submit changes for approval",
      updateAdvertisementWarning: "You are editing a live advertisement!\nYour changes will create a new version requiring approval and split performance reporting from the current ad!\nAre you sure you would like to continue?"
    },
    cancel: "Cancel",
    cgHierarchy: {
      allCommodityGroups: "All Product Categories",
      label: "Product Category",
      labelIms: "{inventoryManagementSystem} Product Category",
      labelImsMulti: "{inventoryManagementSystem} Product Categories",
      labelMulti: "{inventoryManagementSystem} Product Categories",
      noName: "[No Name]"
    },
    discard: "Discard",
    draft: {
      save: "Save as Draft"
    },
    empty: "Empty",
    error: "Error",
    form: {
      activeAgo: {
        day: "{value, plural, one {Active # day ago} other {Active # days ago}}",
        expired: "Never Active",
        hour: "{value, plural, one {Active # hour ago} other {Active # hours ago}}",
        minute: "{value, plural, one {Active # minute ago} other {Active # minutes ago}}",
        month: "{value, plural, one {Active # month ago} other {Active # months ago}}",
        second: "{value, plural, one {Active # second ago} other {Active # seconds ago}}",
        year: "{value, plural, one {Active # year ago} other {Active # years ago}}"
      },
      activeDays: "Active Days",
      activeFor: {
        day: "{value, plural, one {Active for # day} other {Active for # days}}",
        expired: "Never Active",
        hour: "{value, plural, one {Active for # hour} other {Active for # hours}}",
        minute: "{value, plural, one {Active for # minute} other {Active for # minutes}}",
        month: "{value, plural, one {Active for # month} other {Active for # months}}",
        second: "{value, plural, one {Active for # second} other {Active for # seconds}}",
        year: "{value, plural, one {Active for # year} other {Active for # years}}"
      },
      activeIn: {
        day: "{value, plural, one {in # day} other {in # days}}",
        hour: "{value, plural, one {in # hour} other {in # hours}}",
        minute: "{value, plural, one {in # minute} other {in # minutes}}",
        month: "{value, plural, one {in # month} other {in # months}}",
        second: "{value, plural, one {in # second} other {in # seconds}}",
        year: "{value, plural, one {in # year} other {in # years}}"
      },
      activeSince: "Since {date}",
      addAdvertisementSpace: "Add Advertisement Space",
      addProductInfo: "You can add up to {limit, number} products to this advertisement",
      addProductInfoDisruptor: "You can add up to {limit, number} products. The disruptor shows one of them: the first that the store carries.",
      addProducts: "Linked Products",
      addSpace: "Add",
      advertisementSpace: "{type} #{number, number}",
      allSlotTypesFull: "Every type already has the maximum of {limit, number} spaces.",
      beforeLoginRemoved: "The 'Before Login' spaces were removed, as only marketing managers for the selected clients and stores can set them. Save to apply.",
      beforeLoginTimeoutWarning: "This slot will be cut off after {seconds}s.",
      campaignId: "Campaign ID",
      commodityGroupCount: "{count, plural, one {# product category} other {# product categories}}",
      commodityGroupTexts: {
        bc: "Basket Change",
        cgid: "Commodity Group ID",
        cgt: "Commodity Group Trigger",
        cgtt: "Commodity Group Trigger Type",
        is: "Inventory System",
        lu: "Location Update"
      },
      commodityGroupTriggerType: {
        descriptions: {
          onBasketChange: "Shown when a customer adds a product from one of the selected product categories to the shopping cart.",
          onLocationUpdate: "Shown when the shopping cart comes close to the shelves of one of the selected product categories in the store."
        },
        missing: "Please select at least one trigger.",
        title: "Product Category Trigger",
        values: {
          onBasketChange: "Shopping Cart Item Update",
          onLocationUpdate: "Location Update"
        }
      },
      commodityGroups: "Product Categories",
      configureSlots: "Advertisement Spaces",
      copyProductsToAllSlots: "Copy to All Slots",
      createdOn: "Created:",
      days: {
        friday: "Friday",
        monday: "Monday",
        saturday: "Saturday",
        sunday: "Sunday",
        thursday: "Thursday",
        tuesday: "Tuesday",
        wednesday: "Wednesday"
      },
      "delete": {
        commentDescription: "The owner will be notified by email. Please let them know why the advertisement is deleted:",
        commentPlaceholder: "Reason for deleting:",
        deleteSelected: "Delete selected advertisements irrevocably?",
        error: "Failed to delete {count} of the selected advertisements. They remain selected, please try again.",
        message: "Delete this advertisement irrevocably?",
        messageApprovalQueue: "Delete this advertisement (currently waiting for approval) irrevocably?",
        messageDraft: "Delete this advertisement draft irrevocably?",
        no: "No",
        notDeletable: "Published advertisements and those waiting for approval can't be deleted (status \"Waiting\", \"Approved\", \"Active\" and \"Ended\"). Unpublish or reject them first.",
        success: "{count, plural, one {Advertisement irrevocably deleted.} other {# advertisements irrevocably deleted.}}",
        title: "Are you sure?",
        tooltip: "Delete",
        tooltipDraft: "Delete draft",
        yes: "Yes, delete!"
      },
      disableAdvertisement: {
        actionYesDisable: "Yes, Disable Advertisement",
        comment: "Comment (Optional)",
        dialogMessage: "You are about to disable this advertisement. Once it has been disabled, it has to be re-approved to be enabled again. Are you sure?",
        dialogTitle: "Disable Published Advertisement?"
      },
      discardChanges: {
        message: "There are unsaved changes. Should these be discarded?"
      },
      done: "Done",
      duplicateSlot: "Duplicate Slot",
      duration: "Duration (Seconds)",
      editAdvertisementSpace: "Edit \"{name}\"",
      endDate: "End Date",
      exclusive: "Exclusive",
      file: "File",
      fileCount: "{count, plural, one {# file} other {# files}}",
      foreignStores: "{count, plural, one {# store outside your access} other {# stores outside your access}}",
      format: "Format",
      genericInfo: "General Information",
      hiddenOverlap: "{count, plural, one {Plus # advertisement you have no access to.} other {Plus # advertisements you have no access to.}}",
      info: "If a section in the calendar is white, the slot is available.\n\nThe green box means it's the currently selected slot.\n\nThe red box or triangle indicates that the slot is already occupied by another ad.",
      isDisabled: "Deactivate",
      isDisabledEnabled: "Deactivated",
      isWhitelisted: "Only customers who are explicitly activated",
      issuer: "Organization",
      iterations: "Iterations (Default = 1)",
      iterationsUpdate: "Iterations",
      lastUpdates: {
        header: {
          field: "Field",
          modifiedOn: "Modified On",
          newValue: "New Value",
          oldValue: "Prior Value",
          timeframe: "Time period of submitted changes since last review "
        },
        symbols: {
          empty: "Empty",
          "false": "False or Disabled",
          "true": "True or Enabled"
        },
        title: "Latest Changes Awaiting Approval"
      },
      liveNow: "LIVE NOW",
      liveOn: "Live on {date}",
      managerFieldsReset: "The priority was reset to normal and the 'Before Login' spaces were removed, as only marketing managers for the selected clients and stores can set them. Save to apply.",
      maxFileSize: "Max file size: {limit} MB",
      mediaTypes: {
        disruptor: "Disruptor",
        image: "Image",
        slideshow: "Slideshow",
        video: "Video"
      },
      modifiedOn: "Modified:",
      name: "Name",
      noFiles: "No files",
      noResults: "There are no matches to this search. Please make sure you wrote the correct information.",
      olderVersionActive: "An older version of this advertisement has been published.",
      olderVersionApproved: "An older version of this advertisement has been approved.",
      oncePerUser: "Once per customer",
      pastVersion: "Past Version",
      plan: "Targeting & Delivery Rules",
      preview: "Preview",
      priority: "Priority",
      priorityReset: "The priority was reset to normal, as only marketing managers for the selected clients and stores can change it. Save to apply.",
      productCount: "{count, plural, one {# product} other {# products}}",
      productOrderHint: "Only the first product the store carries is shown, the others are fallbacks for stores without it. Drag to change the order.",
      productPosition: {
        description: "This is where the product will be placed within the disruptor. Drag it or use the arrows.",
        down: "Move down",
        left: "Move left",
        noImage: "Upload an image to place the product on it.",
        right: "Move right",
        size: "Size: {width} px × {height} px",
        title: "Product Position",
        up: "Move up"
      },
      productSource: {
        fixed: "Fixed Products",
        personalized: "Personalized",
        personalizedInfo: "Picked for each customer when the ad triggers: a product they bought before from the triggering category that has an active digital coupon, otherwise one with an action price. Products already in the basket or on the shopping list are skipped. Without a matching product, the ad isn't shown.",
        placeholder: "Personalized Product"
      },
      productsCopiedToSlots: "{count, plural, one {Products applied to # slot} other {Products applied to # slots}}",
      promotedProductId: "Product ID",
      promotedProducts: "Promoted Products",
      removeFile: "Remove file",
      removeForeignStores: "Remove",
      removeSlot: "Remove Slot",
      reorderProduct: "Drag to reorder",
      reorderSpace: "Drag to reorder",
      searchProductsToAdd: "Search products to add (minimum 3 characters)",
      selectStores: "Select Stores",
      selectTenants: "Select Clients",
      selectionLegend: "Selected",
      slot: "Slot",
      slotDescriptions: {
        after_login: "An almost full-screen advertisement displayed immediately after login. Products can be associated with this slot.",
        after_payment: "A full-screen advertisement displayed after the payment process is completed.",
        before_login: "A full-screen advertisement displayed before the user logs in to the cart.",
        before_payment: "An advertisement displayed before the payment process starts.",
        during_payment: "An advertisement displayed while the payment is in progress. Products can be associated with this slot.",
        on_commodity_group: "An advertisement displayed within product categories. It occupies approximately one quarter of the screen and can include associated products.",
        on_commodity_group_disruptor: "A promotional placement within product categories at the side of the screen, showing the linked product on the image."
      },
      slotTypeFull: "Maximum of {limit, number} spaces of this type reached",
      slotTypeManagersOnly: "Only Marketing Managers can add spaces of this type",
      slotTypeOverLimit: "More than the maximum of {limit, number} spaces of this type",
      slotTypeRetired: "Spaces of this type are no longer offered",
      spaceIncomplete: "Incomplete",
      spaceSections: {
        assets: "Assets",
        placement: "Placement & Format",
        triggers: "Triggers"
      },
      startDate: "Start Date",
      statusAndHistory: "Status & History",
      storeBranches: "Retail Formats",
      storeBranchesAll: "All Retail Formats",
      storeCompanies: "Corporations",
      stores: "Stores",
      storesAll: "All Stores",
      storesNot: "Not",
      storesOnly: "Only",
      subIssuer: "Campaign Name",
      tenants: "Clients",
      tenantsAll: "All Clients",
      theseStores: "In These Stores",
      timeBlocked: "Occupied by another advertisement",
      timeFrame: "Period",
      timeOverlap: "{count, plural, one {Overlap with # other advertisement:} other {Overlap with # other advertisements:}}",
      timeSelected: "Selected",
      timeline: {
        activation: "Activation",
        active: "Active",
        approval: "Approval",
        approved: "Approved",
        created: "Created",
        ended: "Ended",
        ending: "Ending",
        ends: "Ends",
        rejected: "Rejected",
        submission: "Submission",
        submitted: "Submitted"
      },
      titleDraftEdit: "Edit Advertisement Draft",
      titleEdit: "Edit Advertisement",
      titleNew: "Create New Advertisement",
      titleReview: "Review Advertisement",
      titleView: "View Advertisement",
      tooltipDisable: "Disable advertisement",
      type: "Type",
      uploadFailed: "Upload failed: {error}",
      uploadFile: "Upload File",
      validTime: "Restrict Time",
      validTimeTo: "To",
      validate: {
        beforeLoginTimeout: "Total display duration exceeds the {seconds}s limit for this slot",
        campaignId: "May only contain numbers",
        disruptorProduct: "Please link at least one product.",
        slotsPerType: "An advertisement can have at most {limit, number} spaces of each type. Please remove the extra ones.",
        slotsRequired: "Please add at least one slot.",
        targetBound: "Please select at least one client or store to show the advertisement in.",
        targetScope: "Please select at least one client, retail format or store for which the advertisement should be displayed.",
        timeOrder: "The second time must be after the first.",
        uploadInProgress: "Please wait until the upload has finished."
      }
    },
    issuerCustomer: "Customer",
    list: {
      advertisement: "Advertisement",
      calendarWeek: "Calendar Week",
      clearFilters: "Reset Filters",
      col: {
        active: "Active",
        advertisementBy: "Created by",
        advertisementGuid: "Advertisement GUID",
        blackListStores: "Excluded Stores",
        branches: "Retail Formats",
        campaignId: "Campaign ID",
        campaignName: "Campaign Name",
        companies: "Corporations",
        createdBy: "Created by",
        createdByAndOn: "Created (Name & Date)",
        createdOn: "Created on",
        disabled: "Deactivated",
        endDate: "End Date",
        issuer: "Organization",
        modifiedBy: "Modified by",
        modifiedByAndOn: "Modified (Name & Date)",
        modifiedOn: "Modified on",
        name: "Name",
        priority: "Priority",
        priorityLevels: {
          high: "High",
          low: "Low",
          normal: "Normal"
        },
        slots: "Slots",
        startDate: "Start Date",
        state: "State",
        storeNumber: "Number of Stores",
        subIssuer: "Campaign Name",
        tenants: "Clients",
        timeLeft: {
          day: "{value, plural, one {# day left} other {# days left}}",
          expired: "Expired",
          hour: "{value, plural, one {# hour left} other {# hours left}}",
          minute: "{value, plural, one {# minute left} other {# minutes left}}",
          month: "{value, plural, one {# month left} other {# months left}}",
          second: "{value, plural, one {# second left} other {# seconds left}}",
          year: "{value, plural, one {# year left} other {# years left}}"
        },
        timeframe: "Time Frame",
        whiteListStores: "Stores",
        whitelisted: "Whitelisted"
      },
      current: "Current",
      draft: "Draft",
      duplicateNormalized: {
        beforeLogin: "'Before Login' spaces removed, as only Marketing Managers can set them.",
        both: "Priority set to normal and 'Before Login' spaces removed, as only Marketing Managers can set them.",
        priority: "Priority set to normal, as only Marketing Managers can set it."
      },
      duplicated: "{count, plural, one {# copy created} other {# copies created}}",
      empty: "Empty",
      emptyTable: "No advertisements found",
      exportCopy: "Copy",
      exportDownload: "Download",
      exportTitle: "Export",
      loading: "Loading",
      na: "Not Applicable",
      noResults: "No Results",
      notApplicable: "Not Applicable",
      past: "Past",
      reset: "Reset Search",
      selectColumns: "Selected Columns",
      selected: "{count, number} selected",
      showDrafts: "Show drafts",
      storesAll: "All",
      storesRestricted: "Restricted",
      thisWeek: "This Week",
      title: "Advertisement Overview",
      today: "Today",
      unknown: "Unknown"
    },
    login: {
      error: "Login Failed",
      forgotPassword: "Forgot your password?",
      password: "Password",
      submit: "Login",
      title: "Login",
      username: "Username"
    },
    mediaType: {
      disruptor: "Disruptor",
      image: "Image",
      none: "None",
      slideshow: "Slideshow",
      video: "Video"
    },
    navigation: {
      ads: "Advertisement",
      logout: "Logout",
      version: "Version: {version}"
    },
    "new": "New",
    no: "No",
    notApplicable: "Not Applicable",
    priorities: {
      high: "High",
      low: "Low",
      normal: "Normal"
    },
    save: "Save",
    saveRuleErrors: {
      beforeLogin: "'Before Login' spaces can only be added by Marketing Managers.",
      priority: "Only Marketing Managers can change the priority.",
      targetNotCovered: "The advertisement targets clients or stores outside your access. Only clients and stores you are responsible for can be selected."
    },
    status: {
      approved: "Approved",
      draft: "Draft",
      ended: "Ended",
      published: "Active",
      rejected: "Rejected",
      waitingForReview: "Waiting"
    },
    topFilters: {
      all: "All",
      cardView: "Tile View",
      columns: "Columns",
      "delete": "Delete",
      deselectAll: "Deselect all",
      duplicate: "Duplicate",
      reset: "Reset Filters",
      searchAd: "Search advertisements",
      selectAll: "Select all"
    },
    treeSelect: {
      queryTooShort: "Too many results, please narrow down your search"
    },
    yes: "Yes"
  },
  masterData: {
    allBranches: "All retail formats",
    allTenants: "All clients",
    branches: "Retail formats",
    companies: "Companies",
    confirmDialog: {
      text: "Are you sure you want to delete the {itemType} \"{item}\"?",
      title: "Delete {itemType} \"{item}\"?"
    },
    error: {
      "18003": {
        message: "It is not allowed to edit or delete Inventory Management Systems.",
        title: "Not allowed"
      },
      "18004": {
        message: "The retail format or corporation is still assigned to stores and therefore cannot be deleted.",
        title: "Still in use"
      }
    },
    inventorySystems: "IMS",
    tenant: "Client",
    title: "Master Data",
    type: {
      branch: "Retail format",
      company: "Corporation",
      inventoryManagementSystem: "Inventory Management System",
      tenant: "Client"
    }
  },
  message: {
    success: "Success"
  },
  mhd: {
    delicatessen: "Gourmet food",
    expired: "Already expired!",
    grocery: "Food items",
    later: "Later",
    today: "Today",
    tomorrow: "{date} (Tomorrow)"
  },
  navigation: {
    NotFoundProducts: "Not Found",
    account: "Account",
    administration: "Administration",
    barcodeClassification: "Barcode Classifications",
    barcodeGenerator: "Barcode Tool",
    buildMonitor: "Build Monitor",
    cartReplacements: "Freshdesk Replacements",
    carts: "Carts",
    cartsInSetup: "In Setup",
    check: "Random Customer Check",
    checkout: "Checkout",
    commodityGroups: "Product Categories",
    customers: "Customers",
    defects: "Defects",
    deployments: "Deployments",
    details: "Details",
    devops: "DevOps",
    dsi: "DSI",
    dsiAnalyze: "Session: {sessionGuid}",
    dsiInconsistentData: "Inconsistent data",
    dsiLiveCheck: "Live Check",
    dsiLong: "Theft Interface",
    easyDealsDetail: "{cartBrandShort} Deal",
    imageClassifier: "Image Classifiers",
    info: "Information",
    infrastructure: "Infrastructure",
    inventory: "Cart Hardware Values",
    loading: "Loading stores..",
    logAnalyzer: "Log Analyzer",
    loginCode: "Admin Code",
    logout: "Logout",
    mapEditor: "Map Editor",
    marketing: "Marketing",
    marketingPlatform: "Marketing Platform",
    masterData: "Master Data",
    mhd: "BBD",
    moveDown: "Move down",
    moveUp: "Move up",
    noBarcode: "No Barcode",
    notAssigned: "Please contact your supervisor since you have not been enrolled to any stores.",
    notAvailable: "Store not available",
    pin: "Pin to top",
    pinned: "Pinned",
    pluHierarchy: "PLU Hierarchy",
    productBrowser: "Product Browser",
    productLabels: "Product Labels",
    products: "Items",
    promotions: "Promotions",
    releaseNotes: "Release Notes",
    releases: "Releases",
    reports: "Reporting",
    sessionHistory: "Session History",
    sessionMonitor: "In the Store",
    settings: "Settings",
    setup: "Cart Setups",
    shelves: "Shelf Locations",
    shelvesOverview: "Shelves",
    storeLogAnalyzer: "Store Log Analyzer",
    storeSettings: "Store Settings",
    stores: "Stores",
    surveys: "Surveys",
    unpin: "Unpin",
    users: "Users",
    usersEmptySearch: "No user matched your search",
    version: "Version: {version}",
    waitingTime: "Waiting Time"
  },
  newEntry: "New entry",
  no: "No",
  noBarcode: {
    bakery: "Bakery",
    beverages: "Beverages",
    confirm: "Are you sure?",
    deleteProduct: "Delete added product",
    empty: "No Results",
    fruitsAndVegetables: "Fruits&Veggies",
    gtinOrId: "GTIN or item ID",
    hasGtin: "Other gtin: ",
    info: {
      active: "Active",
      auto: "Last sale < 30 days",
      manualActive: "Added Manually",
      manualInactive: "Manually set to inactive",
      notActive: "Deactivated Manually",
      title: "Information"
    },
    input: {
      active: "Active",
      automatic: "Auto",
      inactive: "Inactive"
    },
    notAdded: "Item not added",
    notFound: "No items found! ",
    notPossibleToEdit: "Editing items not possible",
    others: "Other",
    productAlreadyExists: "This product is already in the list and cannot be added again.",
    search: "Search Gtin",
    searchNotFound: "No Results",
    sort: {
      active: "Active",
      brand: "Brand",
      gtin: "Gtin",
      name: "Name",
      price: "Price",
      removable: "Delete",
      title: "Sort by: "
    },
    title: "No Barcode"
  },
  noItems: "No items",
  notFound: "Not found",
  nutrition: {
    carb: "carbs per 100g",
    fat: "fat per 100g",
    protein: "protein per 100g"
  },
  ok: "Ok",
  old: "Older",
  or: "or",
  paymentMethod: {
    apple_google_pay: "Apple/Google Pay",
    cashier: "At the checkout",
    creditcard: "Via app",
    direct_debit: "Direct debit",
    "edeka-app": "EDEKA App",
    edeka_app_payment: "EDEKA App"
  },
  paymentRequestGuid: "Payment Request Guid",
  paymentStatus: {
    Completed: "Completed",
    Created: "Ready",
    CustomerCancelled: "Canceled by customer",
    EmployeeCancelled: "Canceled by cashier",
    EmployeeReset: "Reset by cashier",
    NewPaymentRequestCreated: "Restarted",
    PaymentProviderDecline: "Denied by payment provider",
    PendingVerification: "Verifications",
    PosBackchannelCancelled: "Canceled by POS",
    SystemCancelled: "Canceled by system"
  },
  pluForm: {
    createBargain: "Create price bargain",
    editBargain: "Edit price bargain",
    fillInThisField: "Please fill in this field",
    selectAtLeastOne: "Please select at least one result",
    selectValidPeriodFrom: "Please select a valid period (from)",
    selectValidPeriodUntil: "Please select a valid period (until)"
  },
  pluHierarchy: {
    upload: "Upload PLU Hierarchy",
    warnings: {
      collapse: "Collapse",
      expand: "View warnings",
      title: "{count, plural, one {# warning from the latest upload} other {# warnings from the latest upload}}"
    }
  },
  pluHierarchyImport: {
    duplicateItem: {
      description: "{count, plural, one {# imported item} other {# imported items}} would create a duplicate in the hierarchy. Import continued without {count, plural, one {that item} other {those items}}.",
      title: "Duplicate item skipped"
    },
    imageResourceMissing: {
      description: "{count, plural, one {# image} other {# images}} referenced by the catalogue {count, plural, one {was} other {were}} not present in the archive. Import continued without {count, plural, one {that image} other {those images}}.",
      title: "Missing image resources"
    },
    imageResourceUndefined: {
      description: "{count, plural, one {# item or category} other {# items or categories}} in the catalogue {count, plural, one {has} other {have}} no image resource defined.",
      title: "Image resource undefined"
    },
    imageResourceUploadFailed: {
      description: "{count, plural, one {# image resource was} other {# image resources were}} present but could not be read or uploaded. Import continued without {count, plural, one {that image} other {those images}}.",
      title: "Image upload failed"
    },
    textResourceMissing: {
      description: "{count, plural, one {# item or category} other {# items or categories}} in the catalogue {count, plural, one {has} other {have}} no name in any language.",
      title: "Missing names"
    }
  },
  priceForm: {
    createPriceOverride: "Create price override",
    editePriceOverride: "Edit price override"
  },
  priceTypes: {
    action: "Sale",
    discount: "Discount",
    free: "Free"
  },
  print: "Print",
  prod: "PROD",
  product: {
    active: "Active",
    barcodeScanner: "Barcode Scanner",
    bbd: "BBD Group...",
    bbdGroup: "BBD Group...",
    bbdSelect: "Select all",
    brand: "Brand",
    changePicture: "Change picture",
    changeProductName: "Change product name",
    confirmDeletion: "Are you sure?",
    contents: "Contents/Quantity",
    deleteProducts: "Delete Products",
    forceActive: "Product status",
    heavy: "Heavy",
    "import": "Import",
    inactive: "Inactive",
    insertaProductName: "Insert a product name",
    itemDetails: "Item Details",
    light: "Light",
    loadingProduct: "Product is loading...",
    name: "Name",
    nameValidation: "The name should contain at least 3 letters. ",
    noHistory: "The product has no field changes",
    notFoundProducts: "Not Found Products",
    notHeavy: "Not Heavy",
    notLight: "Not light",
    notPossibleToUpload: "No picture can be uploaded",
    productDetails: "Product Details",
    productHistory: "Product History",
    productNameLoading: "Product name is being loading",
    productNotFound: "Product not found",
    productSelection: "{count, number} Products will be deleted. ",
    selectAll: "Select all",
    statistics: "Wichtige Statistik",
    unitOfMeasure: "Unit of measure",
    unknown: "Unknown product",
    uploadFailed: "Upload not possible"
  },
  productBrowser: {
    actionPrice: "Sale Price",
    active: "Active",
    ageRestriction: "Age Restriction: {age, number} years old",
    allProductGroups: "All product groups",
    allSubCommGroups: "All sub product groups",
    assignLabelsPlaceholder: "Assign labels to this product",
    assignSource: {
      cgLongId: "auto",
      direct: "manual"
    },
    assignedLabels: "Assigned labels",
    assignedLabelsDescription: "Labels assigned to this product either directly or via a product groups",
    assigningLabel: "Assigning label...",
    brand: "Product brand",
    brandShort: "Brand",
    capacity: "Capacity",
    changeImage: "Change Image",
    changesNeedTimeDeleteMessage: "Current image has been removed successfully and the previously used image will be restored. It can take a few minutes until this change is visible.",
    changesNeedTimeTitle: "Changes need time until visible",
    changesNeedTimeUploadMessage: "New image has been uploaded successfully, but it can take a few minutes until this change is visible.",
    commodityGroup: "Product Group",
    contents: "Unit",
    deletedOn: "Deleted on: ",
    deletion: {
      hint: {
        gtins_moved: "The product has lost all of its GTINs because the GTINs have moved to another product. Hence it is set deleted",
        missing_in_full_dump: "The processing source was a full dump and did not contain the product that was marked deleted",
        not_operated: "The processing source marked this product as not being operated in the given store",
        set_deleted: "The processing source marked the product as deleted",
        uom_missing: "The unit of measure (e.g. ST or KOA) does not exist anymore for a given root item ID"
      },
      localKey: {
        gtins_moved: "GTINs moved",
        missing_in_full_dump: "Missing in full dump",
        not_operated: "Not operated",
        set_deleted: "Set deleted",
        uom_missing: "Unit of measure missing"
      },
      source: "Source: {reason}",
      title: "Deleted Product"
    },
    details: "Product details",
    didYouMean: "Did you mean",
    discountable: "Discountable",
    display: "Display",
    doNotExist: "This product does not exist in this store.",
    excludedLabels: "Excluded labels",
    excludedLabelsDescription: "Labels that are manually excluded from this product",
    filename: "Filename: ",
    filenameRwws: "RWWS filename: ",
    fillOutComment: "Please fill in the comment field",
    filterActive: "Active Products",
    filterAll: "All Products",
    filterInactive: "Inactive Products",
    filterProductLabels: "Products to be labelled",
    flag: "Flag: {flag}",
    flags: "Flags",
    foodFlags: "Product Info",
    force: "(force)",
    from: "From: ",
    fuzzy: "Search for similar terms",
    fuzzyResults: "Results for similar terms",
    gtin: "GTIN",
    hasActionPrice: "Has Action Price",
    hasSalesLimitQty: "Has Sales Limit",
    hasShelfNumbers: "Has Shelf Numbers",
    id: "Item ID",
    isNew: "New Products",
    isWeight: "Weight product",
    labels: "Labels",
    lastImport: "Last import: ",
    legend: "Legend",
    modifiedOn: "Last import: ",
    modifiedRwwsImportOn: "RWWS last import: ",
    name: "Product name",
    nameSearch: "Name",
    noFlag: "Any flags",
    noResults: "No matches",
    nutrition: "Nutrition",
    pos: {
      title: "POS Status"
    },
    price: "Price",
    purchaseDate: "Last purchase date ",
    recentItems: "Recent Items",
    relatedProducts: "{count, plural, one { Other Option: } other { Other Options: }}",
    reloadLabelList: "Clear labelled products",
    removeTag: "Remove tag",
    removedTag: "Removed tag",
    resolvedLabels: "Resolved labels",
    resolvedLabelsDescription: "Final calculated list of labels for this product. Includes assigned labels and their ancestors, but excludes excluded labels. This is what will be used by search/recipes/etc.",
    rwws: {
      title: "RWWS Status"
    },
    salesLimitQty: "Sales Limit",
    search: "Search",
    searchInfo: "Only active products can be found by name, brand, flags, action price and shelf numbers.",
    selectRiscOrTag: "Please select a risk level or tag",
    shelf: {
      add: "Add shelf",
      title: "Shelf"
    },
    shelves: {
      add: "Add shelf",
      title: "Shelf"
    },
    showDeleted: "Show Deleted Products",
    showingRecents: "You can search or narrow down the selection to find items",
    sortByDate: "Sort by date",
    specialFeatures: "Special features",
    status: "Status",
    tags: "Tags",
    title: "Product Browser",
    to: "To: ",
    weight: "Weight"
  },
  productImport: {
    action: "Download Import Template",
    confirmImport: "Start the import?",
    confirmImportText: "Products found in the file {fileName} will be imported",
    download: "Download as XML",
    error: "Could not import products: {message}",
    "import": "Import to Database",
    infoText: "{countProducts, plural, one {# product} other {# products}} recognized with {countBundle, plural, one { # bundle } other { # bundles }}",
    infoTextBundle: "{count, plural, one { with # bundle } other { with # bundles }}",
    instructions: "Create products from template",
    title: "Import Products"
  },
  productLabel: {
    addConnection: "link or create label",
    addLabelToProduct: "Add product",
    createDialog: {
      title: "Create new label \"{count}\"?"
    },
    createLabel: "Create label: ",
    delayHint: "Changes may take a few minutes to be visible.",
    "delete": {
      text: "The label will be removed if it does not have any children.",
      title: "Delete the product label “{ labelName }”?"
    },
    deleteLabel: "Delete label",
    errors: {
      cannotDeleteWithChildNodes: "Product label cannot be deleted as long as it has child nodes",
      labelAlreadyExists: "Product label already exists"
    },
    imageClassifierNetworks: "Image classifier networks",
    imageClassifierNetworksDescription: "Select the network(s) that are used to classify product belonging to this label.",
    label: "Product label",
    labelTitle: "Label name",
    noLabelFound: "No Label Found",
    noProductsFound: "No products with the current label found",
    notExhaustive: "There are likely more products that are not displayed here. Adjust filters to find the right one.",
    products: "Products",
    productsWithLabel: "{labelName} - Products",
    removeLabel: "Remove connection to current label",
    removeLabelFromSelection: "Remove label from selection",
    revertChanges: "Revert changes to current product label",
    showProducts: "Show products",
    startTypingToFindProducts: "Type a product name to see options",
    success: {
      addMany: "{productCount} products successfully added to {labelName}",
      addOne: "{productName} successfully added to {labelName}",
      remove: "{productCount, plural, one {# product successfully removed from {labelName}} other {# products successfully removed from {labelName}}}"
    },
    synonyms: "Synonym",
    table: {
      brand: "Brand",
      cgLongId: "Sub Product Category",
      labelDistance: "Label Distance",
      name: "Name"
    },
    title: "Product label...",
    toBeDeleted: "To be deleted",
    undoAllDelete: "To undo all press the key `Esc`"
  },
  productPicker: {
    ean: "EAN",
    itemId: "Item ID",
    loading: "Searching…",
    noResults: "No products match the search.",
    placeholder: "Search by name, brand, EAN or item ID (min. 3 characters)"
  },
  profile: {
    activation: {
      invalidToken: "Your token is invalid. Please request a new activation e-mail. ",
      newUser: "Set a password to complete the registration.",
      passwordReset: "Set a new password.",
      submit: "Set password"
    },
    addScope: "Add scope...",
    addStore: "Add store...",
    addTenant: "Add client...",
    changePassword: "Change password",
    confirmDeletion: "Are you sure you want to delete the user?",
    createUser: "Create User",
    "delete": "Delete",
    deleteUser: "Delete user",
    editUser: "Edit user",
    email: "E-mail address",
    error: "Failed to create user:",
    errors: {
      "0": "Ok",
      "1": "Unknown error",
      "10": "Welcome e-mail could not be sent: \"{contextValue}\"",
      "2": "Permission for {contextValue} was denied",
      "3": "Permission is invalid (roles: {contextValue})",
      "4": "{contextValue} is already in use",
      "5": "Account does not exist (accountGuid: {contextValue})",
      "6": "Input is invalid: {contextValue}",
      "7": "Store not found (storeGuid: {contextValue})",
      "8": "No client was selected for the account {contextValue}",
      "9": "No store was selected for the account (storeGuid: {contextValue})"
    },
    firstName: "First name",
    forgotPassword: {
      link: "I forgot my password",
      message: "Enter your account e-mail address so that we can send you further instructions.",
      submit: "Send e-mail",
      title: "Forgot your password?",
      validations: {
        email: "Please enter a valid e-mail address"
      }
    },
    global: "Global",
    inaccessibleUser: "Inaccessible user",
    language: "Language",
    lastName: "Last name",
    login: {
      captchaInvalidOrExpired: "Captcha invalid or expired",
      invalidStoreToken: "Invalid store token",
      login: "Login",
      minimumLength: "Minimum length: {currentLength}/8 characters",
      newPassword: "New password",
      noPassword: "No Password",
      noStoreToken: "You need your store's wifi access in order to login.",
      noUserName: "No Username",
      oldPassword: "Old password",
      password: "Password",
      repeatNewPassword: "Repeat new password",
      requiredField: "Required",
      title: "Welcome!",
      unknownError: "Unknown error",
      username: "Username",
      wrongPassword: "Wrong password",
      wrongPasswordOrUser: "Wrong username / password",
      wrongStoreToken: "You are not authorized to login to this store."
    },
    newPassword: "New password",
    newPasswordRepeat: "Confirm new password",
    oldPassword: "Old password",
    password: "Password",
    permissions: "Permissions",
    personalData: "Personal data",
    resetPassword: "Reset Password",
    roles: {
      admin: "Admin",
      auditor: "Auditor",
      cashier: "Cashier",
      customerLabelling: "Customer Labelling",
      demo: "Demo",
      detective: "Detective",
      devops: "DevOps",
      dsi: "DSI",
      foodAcademy: "Food Academy",
      itOperations: "IT Operations",
      labelling: "Product Label",
      maintenance: "Maintenance",
      mapEditor: "Map Editor",
      marketingCreator: "Marketing Creator",
      marketingManager: "Marketing Manager",
      mhd: "BBD",
      pentland: "Pentland",
      peopleCounter: "People Counter",
      rollout: "Rollout",
      securityOfficer: "Security Officer",
      service: "Service",
      storeManager: "Store Manager",
      technician: "Technician"
    },
    rolesNotSaved: "Roles for {scopes} could not be saved: {reason}",
    rolesPartiallySaved: "{count, plural, one {# other scope was saved. The remaining changes are still pending, press Save to try again.} other {# other scopes were saved. The remaining changes are still pending, press Save to try again.}}",
    rolesUpdated: "Roles were saved successfully",
    scopeType: {
      store: "Stores",
      tenant: "Clients"
    },
    selectRoles: "Select roles...",
    tilte: "Your Profile",
    type: {
      "0": "Global user",
      "1": "Store user"
    },
    typeSelection: "Type of user",
    unknownUser: "Unknown user",
    updated: "Profile was updated successfully",
    userAlreadyUsed: "{userName} is already in use",
    userAlreadyUsedFallback: "This user name is already in use",
    userDoesntExist: "User does not exist (anymore)",
    userName: "User name",
    userWithGuidDoesntExist: "User {guid} does not exist (anymore)",
    usersAdministration: "Users Administration"
  },
  promotions: {
    active: "Currently Active",
    addCoupon: "Add coupon",
    addKddr: "Add KDDR",
    addVoucherPromotion: "Add progress bar promotion",
    amount: "Amount",
    amountTooSmall: "Must be greater than 0",
    back: "Overview",
    barcodeError: "Invalid barcode",
    cannotEdit: {
      excludedStores: "You do not have access to all non-excluded stores that this promotion is assigned to",
      outOfScope: "You do not have access to the target that this promotion is assigned to",
      stores: "You do not have access to all stores that this promotion is assigned to",
      tenants: "You do not have access to all clients that this promotion is assigned to",
      title: "Insufficient editing rights"
    },
    changedProperties: "Changed Properties",
    changesHistory: "History of Changes",
    confirmMessage: "Are you sure?",
    coupons: "Coupons",
    created: "Created",
    dateTo: "to",
    dealTemplate: "{cartBrandShort} Deal Template",
    "delete": "Delete promotion",
    deleteItems: {
      confirm: "This cannot be undone",
      coupon: "Delete KDDR promotion?",
      deleteAllStores: "Delete for all stores",
      deleteOnlyStore: "Delete only for this store",
      easyDeal: "Delete {cartBrandShort} deal?",
      easyDealCollection: "{count, plural, one {Delete  one {cartBrandShort} deal?} other {Delete # {cartBrandShort} deals?}}",
      exit: "Exit",
      loyaltyPass: "Delete loyalty pass?",
      remainingDays: "{count, plural, one {# day left} other {# days left}}",
      sureExit: "Are you sure you want to exit?",
      unsavedChanges: "Any unsaved changes will be lost",
      voucherPromotion: "Delete progress bar promotion?"
    },
    deleted: "Deleted",
    discount: "Coupon Discount",
    duplicate: "Duplicate",
    easyDeal: "{storeBrand} Coupon",
    easyDeals: "{cartBrandShort} Deals ({count})",
    emptyField: "Empty field",
    end: "End date",
    error: "Not possible to update",
    filter: {
      coupon: "Coupons",
      easyDeal: "{cartBrandShort} Deals",
      kddr: "KDDR",
      loyalty: "Loyalty Rewards",
      voucherPromotion: "Progress bar promotions"
    },
    importEasyDeals: "Import {cartBrandShort} deals",
    inactive: "Currently not active",
    invalidEntry: "Invalid entry",
    kddr: "{percentage}% Stick Your Own Discount",
    loyaltyRewards: {
      activatable: "Coupon can be activated",
      add: "Add loyalty rewards",
      customerInfo: "Customer info",
      discount: "Discount",
      discountShortDescription: "Short discount description internal",
      discountTitle: "Discount description for customers",
      discountValidity: "Cash in time frame",
      gtinPlu: "Deal GTIN/PLU",
      image: {
        "default": "Default image",
        defaultInfo: "Fallback image will be used",
        imageType: "Image Type",
        imageUrl: "Image URL",
        noImage: "No image",
        title: "Image",
        upload: "Upload image"
      },
      isActive: "Active",
      minSessionAmount: "Required amount of shopping sessions",
      minSessionTotal: "Min. amount in basket",
      minSessionTotalToRedeem: "Min. amount to cash in",
      promotion: "Promotion",
      showProgress: "Promotion Pop-Up after login",
      subtitle: "Subtitle",
      text: {
        dragAndDrop: "Drag and Drop Discount Image here",
        selectImage: "Select Discount Image"
      },
      title: "Title",
      titlebarTitle: "Loyalty Rewards",
      validity: "Time frame",
      validityErrorMessage: "Discount cash-in date has to start after the validity start and end after the validity end"
    },
    name: "Discount Name",
    noChangesInPromotion: "No Changes in Promotion",
    noChangesInStores: "No Changes in Affected Stores",
    period: "Period:",
    responsability: {
      furtherDevelopment: "Further Development",
      indoorService: "Indoor Service",
      rolloutPreparation: "Rollout Preparation",
      support: "Support",
      title: "Responsibility"
    },
    responsibility: {
      furtherDevelopment: "Further Development",
      indoorService: "Indoor Service",
      responsibleParty: "Responsible Party",
      rolloutPreparation: "Rollout Preparation",
      support: "Support",
      title: "Responsibility"
    },
    start: "Start date",
    title: "Promotions",
    today: "Today",
    totalBranches: "Total number of affected retail formats",
    totalExcludedStores: "Total number of excluded stores",
    totalIncludedStores: "Total number of included stores",
    tryAgain: "Try again",
    updateCouponPromotion: "Edit KDDR",
    updateVoucherPromotion: "Edit Progressbar Promotion",
    upload: "Successfully uploaded!",
    uploadCouponPromotion: "Add KDDR",
    uploadEasyDealsError: {
      "0": "Unknown error in column {column} row {row}",
      "1": "Discount is ambigious (column {column}, row {row})",
      "2": "Data type is invalid (column {column}, row {row})",
      "3": "Required value is missing (column {column}, row {row})",
      "4": "Unknown StoreId (column {column}, row {row})",
      "5": "Invalid file format",
      "6": "Missing column ({column})"
    },
    uploadVoucherPromotion: "Add Progressbar Promotion"
  },
  pushNotification: {
    noNavi: "No navi",
    title: "Push Notifications"
  },
  pushTopics: {
    cashierTerminal: {
      message: "Cashier Terminal"
    },
    imageDetection: {
      message: "Image Detection"
    },
    required: "Unsubscribed",
    sessionMonitor_admin: {
      message: "Admin",
      section: "In the Store"
    },
    sessionMonitor_detective: {
      message: "Detective",
      section: "In the Store"
    },
    sessionMonitor_service: {
      message: "Service",
      section: "In the Store"
    }
  },
  redo: "Redo",
  releaseNotes: {
    author: "Author",
    collapse: "Show less",
    create: "Create Release Notes",
    current: "Current",
    deletedUser: "Deleted User",
    display: {
      "delete": "Delete Release Notes",
      deleteConfirmation: "Do you really want to delete these release notes?",
      edit: "Edit Release Notes",
      print: "Print",
      publish: "Publish Now",
      title: "Version {title}",
      unpublish: "Undo publication"
    },
    draft: "Draft",
    edit: {
      saveDraft: "Save Draft",
      titleCreate: "Create Release Notes",
      titleEdit: "Edit Version: {title}",
      update: "Update version",
      updateDraft: "Update draft"
    },
    emptySearch: "No release note matched your search",
    expand: "Show more",
    name: "Release name",
    placeholder: "Release description",
    printPreview: "Print - Format document",
    published: "Published",
    publishedAutomaticallyOn: "Published automatically on",
    publishedOn: "Release Date",
    publishedOnPlaceholder: "No date selected",
    title: "Release Notes"
  },
  reload: "Reload",
  remainingDays: "{count, plural, one {# day left} other {# days left}}",
  remove: "Remove",
  rename: "Rename",
  reports: {
    noReports: "No reports available",
    select: "Select report",
    title: "Reporting"
  },
  reset: "Reset",
  resetChanges: "Reset changes",
  restore: "Restore",
  results: "Results ({count})",
  save: "Save",
  search: "Search",
  send: "Send",
  sessionGuid: "Session Guid",
  sessionHistory: {
    WeightWithoutScan: "Weight without scan: ",
    deviation: "Deviation",
    expected: "Expected: ",
    expectedDelta: "Expected delta: ",
    loginWithApp: "Login with app",
    loginWithCard: "Login with card",
    measured: "Measured: ",
    okayAgain: " okay again",
    paymentCanceled: "Payment canceled",
    paymentCompleted: "Payment completed",
    paymentMethod: "Payment method: {method}",
    paymentStarted: "Payment started",
    productWeight: "Product weight: ",
    purchaseFinished: "Purchase finished",
    purchaseStarted: "Purchase started",
    reason: "Reason: ",
    scannedCoupon: "Scanned coupon",
    sessionTransfer: "Session Transfer",
    silent: "Silent",
    weight: "Weight ",
    weightAdjusted: "Weight adjusted:"
  },
  sessionMonitor: {
    claimTicket: "Claim Ticket",
    confirmCustomerMark: "Do you really want to mark this customer?",
    confirmationManualCheckDisable: "Do you really want to disable manual check?",
    confirmationManualCheckEnable: "Do you really want to enable manual check?",
    currentWeight: "Actual: ",
    customerMark: "Mark customer",
    disableManualCheck: "Disable Manual Check",
    disableManualCheckImageView: "Manual Check",
    emptyShoppingCart: "The shopping cart is empty",
    enableManualCheck: "Enable Manual Check",
    enableManualCheckImageView: "Manual Check",
    expectedWeight: "Expected: ",
    express: "Express",
    historyDetails: "Details",
    loadingDevices: "Loading devices",
    loginCode: "Admin Code",
    manualCheck: "Manual Check",
    map: "Map",
    mapActiveCarts: "Active Carts",
    mapInactiveCarts: "Inactive Carts",
    openTickets: "Open tickets: {count, number}",
    ownTicket: "Me",
    releaseTicket: "Release Ticket",
    removeCustomerMark: "Remove customer mark",
    resetTara: "Reset scales deviation?",
    sessionLoading: "Session is loading",
    shopper: "Shopper",
    showDetails: "Show Details",
    sortCartNumber: "Sort by cart number",
    sortDeltaWeight: "Sort by delta weight",
    sortUptime: "Sort by session duration",
    ticketClosed: "Ticket Closed",
    ticketNotAssigned: "Ticket could not be assigned!",
    ticketNotClosed: "Ticket could not be closed!",
    ticketNotReleased: "Ticket could not be released!",
    uptime: {
      days: "{count} days",
      hours: "{count} hours",
      lessThanAMinute: "Less than a minute",
      minutes: "{count} minutes",
      oneSecond: "1 second",
      seconds: "{count} seconds",
      years: "{count} years"
    }
  },
  shelf: {
    backgroundMapOpacity: "Background Map opacity: {opacity}%",
    barcode: "Type in the barcode",
    "delete": "Delete",
    deleteShelves: "Delete shelves",
    easyShopperPosition: "Position the {cartBrand} so that its antenna is as close as possible to the shelf barcode and scan the barcode.",
    failed: "Failed to save shelf: ",
    message: "{count, plural, one { Are you sure that you want to delete this shelf? } other { Are you sure that you want to delete # shelves? }}",
    noNavigationData: "No navigation data",
    notSaved: "Couldn't save",
    oldNavigationData: "Outdated navigation data",
    pickACart: "Choose a cart: ",
    restore: "Restore",
    restoreShelf: "Please choose the shelf that you want to restore",
    save: "Save shelf",
    scan: "Enter a code: ",
    scanShelf: "Scan shelf",
    shelfAlreadyExists: "A shelf with this code already exists",
    shelfScan: "Shelf scan with Cart {cartId}",
    title: "Current shelf spaces",
    undoLastShelf: "Undo last shelf",
    undoLastShelfMsg: "Are you sure that you want to delete shelf {shelfNumber}?",
    upload: {
      pleaseSelect: "Choose a file:",
      title: "CSV Upload"
    },
    uploadMapping: {
      title: "Upload Mapping"
    },
    wifiMsg: "Please make sure that the cart is connected to Wi-Fi and try again."
  },
  showMore: "+{count} more",
  single: "Single",
  status: "Status",
  store: {
    address: {
      city: "City",
      country: "Country",
      countryCode: "Country Code",
      street: "Street",
      zipCode: "Zip Code"
    },
    chargingOptions: {
      addChargingOption: "Add another charging option",
      cartCount: "Number of carts",
      chargerCount: "Chargers",
      chargingController: "Charging controller {name}",
      chargingControllers: "Charging controllers",
      connector: "Charging connector",
      connectors: {
        plugLight: "ES Light Plug",
        plugPremium: "Premium Plug",
        plugPremiumRail: "Premium Plug + Charging Rail",
        plugsLightPremium: "ES Light Plug + Premium Plug",
        rail: "Charging rail"
      },
      description: "Please add all planned charging options. Multiple charging options can be added for each charging type.",
      incompleteError: "Charging option {i} is incomplete. Please fill all required fields.",
      noChargingControllers: "This charging option has no controllers",
      requiredError: "At least one charging option is required.",
      switchCabinetCount: "Number of switch cabinets",
      type: "Charging type",
      types: {
        chargingBox: "Charging box (Outside)",
        chargingStation: "Charging station (Inside)",
        mobileChargingStation: "Mobile charging station (Pentland)",
        mobileChargingUnit: "Mobile charging unit (Extern)"
      }
    },
    create: {
      message: "Please enter foundational information to start",
      title: "Create store"
    },
    golive: "Go-live",
    gps: {
      lat: "Latitude (N/S)",
      lon: "Longitude (E/W)"
    },
    hints: {
      ipv4: "{field} must be a valid IPv4 address in the format xxx.xxx.xxx.xxx, where xxx is a number between 0 and 255",
      length13: "{field} must have a length of 13 characters",
      noLeadingTrailingSpaces: "{field} must not contain leading or trailing spaces",
      noLeadingZeros: "{field} must not contain leading zeros",
      noSpecialCharacters: "{field} must not contain special characters",
      notEmpty: "{field} must not be empty",
      number: "{field} must be a number",
      positiveInteger: "{field} must be a positive integer",
      startWith4313Or4314: "{field} must start with 4313 or 4314",
      threeUppercaseLetters: "{field} must consist of three uppercase letters",
      unique: "{field} must be unique",
      validEan13: "{field} must be a valid EAN-13 code",
      validIso4217CurrencyCode: "{field} must be a valid ISO 4217 currency code",
      validUrl: "{field} must be a valid URL",
      wifiPassword: "{field} must be a valid Wi-Fi Password consisting of 8-63 characters",
      wifiSsid: "{field} must be a valid Wi-Fi SSID consisting of 1-32 characters"
    },
    "import": {
      confirmationText: "Are you sure you want to import the store?",
      confirmationTitle: "Import store",
      description: "Enter at least one of the following search terms to find a store.",
      detailsTitle: "Store details",
      fields: {
        city: "City",
        gln: "GLN",
        name: "Name",
        zipCode: "Zip Code"
      },
      "import": "Import",
      moreInfo: "More info",
      title: "Import Store",
      yesImport: "Yes, import"
    },
    lessInfos: "Show less information",
    milestone: {
      activateProductsAction: {
        title: "Product Activation"
      },
      configBootstrapAction: {
        title: "Copy Configurations"
      },
      createStoreDatabaseAction: {
        title: "Setup Cloud"
      },
      storeCartCheck: {
        title: "Carts Set Up"
      },
      storeCreationBasicInput: {
        field: {
          address: {
            title: "Address"
          },
          area: {
            title: "Sales Area in m²"
          },
          branch: {
            title: "Retail format"
          },
          company: {
            title: "Corporation"
          },
          costCenter: {
            title: "Cost Center"
          },
          countryCode: {
            title: "Country Code"
          },
          currency: {
            title: "Currency"
          },
          enableCreditCardPayment: {
            title: "Enable Credit Card Payment"
          },
          enableDirectDebitPayment: {
            title: "Enable Direct Debit Payment"
          },
          enablePaymentAtCart: {
            title: "Enable payment via app"
          },
          enablePaymentAtCartShort: {
            title: "Payment via app"
          },
          enablePosPromotions: {
            title: "Enable checkout promotions"
          },
          fallbackStore: {
            title: "Fallback Store"
          },
          floorArea: {
            title: "Sales Area (m²)"
          },
          globalLookupNumber: {
            title: "Global Lookup Number (GLN)"
          },
          inventoryManagementSystem: {
            title: "WWS"
          },
          location: {
            title: "GPS of Entrance"
          },
          mposIpAddress: {
            title: "MPOS IP"
          },
          name: {
            title: "Name"
          },
          preferredLanguages: {
            title: "Preferred Languages"
          },
          rwwsMigrationDate: {
            title: "RWWS Migration"
          },
          startsOn: {
            title: "Go Live Date"
          },
          storeGuid: {
            title: "StoreGuid"
          },
          storeId: {
            title: "StoreID"
          },
          storeNumber: {
            title: "Store Nº"
          },
          tenant: {
            title: "Client"
          },
          timezone: {
            title: "Time Zone"
          }
        },
        title: "General Information"
      },
      storeCreationFiBuInput: {
        field: {
          company: {
            title: "Corporation"
          },
          costCenter: {
            title: "Cost Center (If deviating from Store Nº)"
          },
          customerNumberFiBu: {
            title: "Customer Accounting Number (If deviating from StoreID)"
          },
          operatingMode: {
            title: "Operating Form"
          },
          storeNameFiBu: {
            title: "Store Accounting Name (If deviating from Name)"
          }
        },
        title: "Deviating Accounting Data"
      },
      storeCreationImprintInput: {
        field: {
          contacts: {
            add: "Add:",
            sendEmail: "E-mail store manager/director and other contacts",
            title: "Additional E-mail Addresses"
          },
          dealsFlyerUrl: {
            title: "Advertising brochure URL"
          },
          openingHours: {
            title: "Opening Hours"
          },
          storeManagerEmail: {
            title: "Store Manager E-mail"
          }
        },
        title: "Imprint"
      },
      storeCreationRolloutInput: {
        field: {
          cartDeliveryDate: {
            title: "Cart Delivery Date"
          },
          currentNumberOfCarts: {
            asOf: "As of {date}",
            stale: "This figure is from {date} and may be out of date.",
            title: "Current Cart Amount",
            unknown: "No figure available for this store yet."
          },
          esLight: {
            title: "{cartBrand} Light"
          },
          esPremium: {
            title: "{cartBrand} Premium"
          },
          expressShopping: {
            title: "Express Shopping"
          },
          hasCashierCheckout: {
            options: {
              "false": "No",
              "true": "Yes"
            },
            title: "Has Regular Checkout Terminal"
          },
          hasNavigation: {
            title: "Indoor Navigation",
            tooltip: "This setting is read-only here and can be edited in the map editor."
          },
          hasRamps: {
            options: {
              "false": "No",
              "true": "Yes"
            },
            title: "Has Ramps"
          },
          hasSelfCheckout: {
            options: {
              "false": "No",
              "true": "Yes"
            },
            title: "Has Self-Checkout Terminal(s)"
          },
          numberOfCarts: {
            title: "Initial Cart Amount"
          },
          numberOfLights: {
            title: "Number of Light Carts"
          },
          numberOfPremiums: {
            title: "Number of Premium Carts"
          },
          phoneCount: {
            title: "Number of phones for checkout"
          },
          sosPhoneCount: {
            title: "Number of phones for support"
          },
          subcontractor: {
            title: "Supported By"
          },
          voucherPromotions: {
            imsNotSet: "The inventory management system has not been set yet",
            noPromotions: "No progressbar promotions",
            title: "Progressbar Promotions"
          },
          wheelType: {
            options: {
              brake: "Brake",
              ramp: "Ramp",
              standard: "Standard"
            },
            title: "Wheel Type"
          }
        },
        title: "Rollout Information"
      },
      storeCreationTechnicalInput: {
        field: {
          apigeeSettings: {
            title: "Apigee Settings"
          },
          chargingBoxCount: {
            title: "Number of charging boxes (outside)"
          },
          chargingMobileChargersCount: {
            title: "Number of mobile chargers"
          },
          chargingOptions: {
            title: "Charging Options"
          },
          chargingRailCount: {
            title: "Number of charging stations (inside)"
          },
          chargingStationCount: {
            title: "Number of charging stations (inside)"
          },
          chargingSwitchCabinetCount: {
            title: "Number of switch cabinets"
          },
          jumpHostIpAddress: {
            title: "Jump Host IP"
          },
          mobileChargingStationCount: {
            title: "Number of mobile chargers"
          },
          mposAuthHeaderValue: {
            title: "MPOS SSC Cloud Auth Header"
          },
          mposIpAddress: {
            title: "MPOS IP"
          },
          mposSettings: {
            title: "MPOS Settings"
          },
          mposSscCloudIpAddress: {
            title: "MPOS SSC Cloud Address"
          },
          mposSscLocalIpAddress: {
            title: "MPOS SSC Local Address"
          },
          navigationAnchorCount: {
            title: "Navigation anchor count"
          },
          plug: {
            title: "Has Plug"
          },
          rail: {
            title: "Has Rail"
          },
          storeIpAddress: {
            title: "Store IP"
          },
          switchCount: {
            title: "Switch Count"
          },
          wifiProfile: {
            options: {
              custom: "Custom (store-specific)"
            },
            title: "Wi-Fi Profile"
          }
        },
        mposMode: {
          options: {
            mposSscCloud: "MPOS SSC Cloud",
            mposSscLocal: "MPOS SSC Local",
            mposV1: "MPOS v1"
          },
          title: "MPOS Mode"
        },
        title: "Tech Input"
      },
      storeDatawarehouseCheck: {
        title: "Datawarehouse Import"
      },
      storeMigrationInitStage: {
        title: "Init"
      },
      storeMigrationMigrationStage: {
        title: "Migration"
      },
      storeMigrationPrepareStage: {
        title: "Prepare"
      },
      storeMposCheck: {
        title: "POS"
      },
      storePaymentCheck: {
        title: "Payment Provider"
      },
      storeProductImportCheck: {
        title: "Product Import"
      },
      storeProxyCheck: {
        title: "Store Proxy"
      },
      storeServiceBusAction: {
        title: "Service Bus"
      },
      storeServiceFreshDesk: {
        title: "Freshdesk"
      }
    },
    milestoneGroup: {
      infrastructure: "Infrastructure",
      storeInfo: "Information",
      storeMigration: "Store Migration"
    },
    milestoneHistory: {
      changedBy: "Changed by",
      error: "Error",
      message: "Message",
      metaDataDiff: "Metadata Diff",
      metadata: "metadata",
      modifiedOn: "Modified on",
      runType: "Run Type",
      status: "Status",
      title: "History"
    },
    milestoneInfo: "last changed: {date} | {user}",
    milestoneStatus: {
      NOK: "Not successful",
      OK: "Successful",
      RUNNING: "Running",
      SCHEDULED: "Scheduled"
    },
    milestoneType: {
      check: {
        past: "and {count, number} past ones",
        pastDialog: "Past checks:",
        rerun: "Rerun check",
        run: "Check"
      }
    },
    moreInfos: "Show further information",
    noMilestoneHistory: "No milestone history found",
    openingHours: {
      closes: "To",
      opens: "From"
    },
    pleaseSelect: "Please select",
    runAllMilestones: "Run all checks again",
    showDetails: "Show details",
    validations: {
      eanCheckDigit: "Checksum does not equal a valid EAN Nº. (Calculated: {calculated})",
      eanLength: "EAN Nº not valid.",
      eanNoNumber: "EAN Nº not valid.",
      emails: "Invalid e-mail address(es): {emails}",
      max: "Max. Value: {message}",
      maxLength: "Max. Length: {message}",
      min: "Min. Value: {message}",
      minLength: "Min. Length: {message}",
      pattern: "Input does not meet required format: {message}",
      required: "Required Field"
    },
    visibility: {
      hidden: "Store is hidden",
      hideMessage: "Do you want to hide this store? Customers won't be able to see it anymore.",
      hideTitle: "Hide store",
      showMessage: "Do you want to make this store visible? Customers will be able to see it.",
      showTitle: "Show store",
      visible: "Store is visible"
    },
    waitingForDependency: "Requirement not met",
    weeks: {
      later: "Upcoming",
      next: "Next Week",
      past: "Past",
      "this": "This Week"
    },
    wifiProfiles: {
      cart: {
        password: "Cart Wi-Fi password",
        ssid: "Cart Wi-Fi SSID"
      },
      description: "Store-specific credentials can be defined using the \"custom\" profile.",
      market: {
        password: "Store Wi-Fi password",
        ssid: "Store Wi-Fi SSID"
      },
      password: "Wi-Fi password",
      profile: "Profile",
      setup: {
        password: "Setup Wi-Fi password",
        ssid: "Setup Wi-Fi SSID"
      },
      ssid: "Wi-Fi SSID"
    }
  },
  storeGuid: "Store Guid",
  storeMetadata: {
    address: "Address",
    branch: "Retail format",
    cartDeliveryDate: "Cart Delivery",
    city: "City",
    company: "Corporation",
    country: "Country Code",
    create: "Create store",
    editStore: "Edit store",
    email: "Store Manager/Director E-mail",
    failed: "Failed to update/create store",
    from: "From",
    inventoryManagementSystem: "Inventory System",
    location: "GPS Entrance",
    name: "Name",
    newStore: "New store",
    numberOfCarts: "Number of Carts",
    openingHours: "Opening Hours",
    pleaseSelect: "Please select",
    rolloutForm: "Rollout view",
    startsOn: "GoLive",
    storeId: "StoreId",
    storeNumber: "Store Number",
    street: "Street",
    tableForm: "Table view",
    to: "To",
    zipCode: "ZIP Code"
  },
  storeSettings: {
    addOrEdit: "Add or edit multiple settings",
    adminArea: "Admin area",
    allStores: "All stores",
    allTenants: "All clients",
    allowAnonymousLogin: "Allow anonymous login",
    days: {
      articles: "Items",
      days: "Days",
      rate: "Rate",
      time: "Time",
      wholeWeek: "Whole week"
    },
    differingSettings: "Differing Settings",
    enableImageDetection: "Enable Image Detection",
    help: {
      triggerStrategy: {
        detectionCorrect: "Random Check is triggered if Live DSI confirmed at least one; cashier isn't asked for confirmation",
        detectionCorrectOrNotConfirmed: "Random Check is triggered if Live DSI or cashier confirms at least one",
        detectionExists: "Random Check is triggered if cashier confirms at least one; Live DSI is ignored when negative"
      }
    },
    imageDetections: {
      thresholdSettings: "Image Detection Threshold Settings",
      triggerStrategy: "Image Detection Trigger Strategy"
    },
    itemsToCheckLargeBasket: "# check items large purchase",
    itemsToCheckSmallBasket: "# check items small purchase",
    layer: "Layer",
    multiple: "multiple",
    noSettingsFound: "No store settings were found for {storeName}",
    piecesShortForm: "pc.",
    quota: "Quota",
    randomCheck: "Random Check Settings",
    randomCheckAtCart: "Random check at cart",
    randomCheckQuota: "Random check quota",
    sectionDisabledBecauseBranches: "The \"{section}\" settings are only available as long as no branch is selected.",
    settingsRandomCheck: "Settings random check",
    stores: "Stores",
    submitForEverythingDialog: {
      confirm: "Override all settings",
      message: "This will override all settings in all stores you have access to.",
      title: "Override all settings for all stores?"
    },
    tenants: "Clients",
    thresholdLargeBasket: "Considered a large purchase at",
    timeError: "End time has to be grater than start time",
    units: {
      count: "pcs"
    },
    validations: {
      smallCheckItemsCannotExceedItemsToCheckLargeBasket: "has to be smaller than the # check items large purchase",
      smallCheckItemsCannotExceedLargeBasketThreshold: "has to be smaller than the large basket threshold"
    },
    welcomeVideo: {
      newVideo: {
        add: "Add Videos",
        drop: "Drop here",
        error: {
          fileSize: "File too large: {current, number}MB > {limit, number}MB",
          noFile: "No File",
          typeNotSupported: "File type not supported: {type}",
          uploadFailed: "Upload failed"
        },
        upload: "Upload Video"
      },
      popUp: {
        "delete": {
          message: "Are you sure you want to delete this video?",
          subMessage: "This action cannot be undone.",
          title: "Delete Video"
        },
        remove: {
          message: "Are you sure you want to remove this video?",
          subMessage: "This will affect all stores using this video.",
          title: "Remove Video"
        }
      },
      title: "Welcome Video",
      tooltips: {
        addVideo: "Add video to be shown on login screen",
        addVideoLoginScreen: "Add video to login screen",
        changeVideo: "Change video",
        changeVideoLoginScreen: "Change video on login screen",
        deleteVideo: "Delete video",
        onlyOneVideo: "Only one video can be added at a time",
        removeVideo: "Remove video from login screen",
        uploadOrDelete: "Upload or delete videos to be shown on login screen"
      },
      videoData: {
        addedOn: "Added on {date}",
        duration: "{duration, number} seconds",
        name: "Name: {name}"
      }
    },
    withUser: "With Login",
    withoutUser: "Without Login"
  },
  stores: "Stores",
  success: "Success",
  supportInfo: {
    addPicture: "Add picture",
    dropPicture: "Drop picture here",
    events: {
      title: "Events"
    },
    generalNotes: "General notes",
    noImage: "The selected file is not an image",
    noSections: "There are no sections yet. Create some to get started.",
    pasteDropPicture: "Or Paste/Drop a picture",
    pictureNotes: "Notes regarding the picture",
    removePicture: "Remove picture",
    sections: {
      errors: {
        mustBeUnique: "Section names must be unique",
        required: "Required"
      },
      link: "Configure Sections",
      title: "Configure Sections"
    },
    selectPicture: "Select a picture",
    support: {
      title: "Documentation"
    },
    title: "Support Information"
  },
  surveys: {
    add: "Add survey",
    bulkDelete: {
      confirm: "{count, plural, one {Are you sure you want to delete the selected survey?} other {Are you sure you want to delete ALL # selected surveys?}}",
      confirmButton: "Delete",
      title: "Delete Surveys"
    },
    "delete": "Delete selected surveys",
    edit: "Edit survey",
    "export": {
      answer: "Answer",
      count: "Count",
      end: "End",
      flowSheet: "Flow Diagram",
      generalInfo: "General Information",
      icon: "Excel Export",
      id: "ID",
      optionRemoved: "[This option has been removed]",
      options: "Options",
      smileyOptions: {
        dissatisfied: "Dissatisfied",
        neutral: "Neutral",
        satisfied: "Satisfied"
      },
      source: "Source",
      start: "Start",
      store: "Store",
      target: "Target",
      timestamp: "Timestamp",
      type: "Type"
    },
    flow: {
      excludedTextQuestions: "{count, plural, one {# free-text question isn't shown in the flow diagram} other {# free-text questions aren't shown in the flow diagram}}",
      exportSvg: "Export flow diagram as SVG",
      hoverHint: "Hover a node or connection for details",
      respondents: "Respondents",
      showCharts: "Show charts",
      showFlow: "Show flow diagram"
    },
    hideLayer: "Hide layer selection",
    newOptionPlaceholder: "New Option",
    question: "Question",
    select: {
      checkbox: "Checkbox",
      radio: "Radio",
      smiley: "Smiley",
      text: "Text",
      title: "Select Question Type"
    },
    settings: "Settings",
    showLayer: "Show layer selection",
    slots: {
      during_payment: "During and after Payment"
    },
    survey: {
      active: "Active",
      askCustomer: "Ask Customer for participation",
      cart: "Cart",
      description: "Description",
      hideComments: "Hide responses",
      interval: "Days",
      mobile: "Mobile App",
      mobileApp: "Mobile App",
      name: "Survey Name",
      noResults: "No Results Available Yet",
      optional: "Ask Customer for participation",
      repeat: "Repeat",
      repeatAfter: "After",
      showAllComments: "Show all responses",
      showToAnonymous: "Show to anonymous users",
      slot: "Slot",
      title: "Title",
      validity: "Validity"
    },
    surveyQuestions: "Survey Questions",
    table: {
      active: "Active",
      askCustomer: "Ask Customer",
      cart: "Cart",
      endsOn: "End Date",
      mobileApp: "Mobile App",
      name: "Name",
      optional: "Optional",
      questionCount: "Questions",
      slot: "Slot",
      startsOn: "Start Date",
      validFrom: "From",
      validTo: "To"
    },
    textAnswer: "Text Answer",
    validation: {
      emptyOption: "Option cannot be empty"
    }
  },
  table: {
    calendarWeekShort: "CW",
    clearFilters: "Clear filters",
    deselectAll: "Deselect all",
    exportCopy: "To clipboard",
    exportDownload: "Download",
    exportTitle: "Export",
    hiddenColumnFilters: "Filters of hidden columns",
    hideAllColumns: "Hide all",
    lastSevenDays: "Last 7 days",
    lastThirtyDays: "Last 30 days",
    loading: "Loading",
    noResults: "No results",
    rangeMax: "Max",
    rangeMin: "Min",
    reset: "Reset",
    resetAll: "Reset table settings",
    selectColumns: "Select visible columns",
    selected: "{count, number} selected",
    showAllColumns: "Show all",
    thisMonth: "This month",
    thisWeek: "This week",
    thisYear: "This year",
    today: "Today"
  },
  test: "TEST",
  tickets: {
    anotherReason: {
      label: "Another reason"
    },
    cashierRequest: {
      label: "Open additional checkout"
    },
    changeItemCount: {
      label: "Could not change item amount"
    },
    checkoutAssistance: {
      label: "Customer needs assistance at checkout"
    },
    closed: " closed",
    expensiveProductRemoved: {
      label: "Expensive item removed"
    },
    itemsRemovedBeforePayment: {
      label: "Items removed"
    },
    multiSession: {
      label: "This customer has already made several purchases with the {cartBrand} today."
    },
    operationUnclear: {
      label: "Operation {cartBrand} unclear"
    },
    priceDifference: {
      label: "Price difference"
    },
    productAdvice: {
      label: "Product advice required"
    },
    productNotFound: {
      label: "Product not found"
    },
    productsRemoved: {
      label: "Removed Products",
      message: "Products removed from the basket: ",
      quantity: "Quantity: {quantity}",
      totalAmount: "Total: {totalAmount} "
    },
    scanWithoutRunningSession: {
      label: "Scan without session"
    },
    scannerProblems: {
      label: "Problem with the scanner"
    },
    sos: {
      label: "SOS"
    },
    taggedCustomer: {
      label: "Customer Mark",
      message: "Marked customer logged in"
    },
    tooManyDiscountedProducts: {
      label: "Too many discounted items"
    },
    unknownBarcode: {
      label: "Unknown barcode"
    },
    unknownBarcodeSOS: {
      label: "Help Request for unknown barcode"
    },
    weightDeviation: {
      label: "Weight deviation"
    },
    weightOnCartWithoutSession: {
      label: "Weight on cart without session"
    }
  },
  timeFrame: "Time frame",
  today: "Today",
  treeSelect: {
    queryTooShort: "Too many results, please narrow down your search"
  },
  undo: "Undo",
  undoAll: "Undo all",
  unknown: "Unknown",
  unknownError: "Unknown Error: {error}",
  unsavedConfirmation: "Changes you made may not be saved.",
  updateAvailable: {
    cancel: "Not now",
    message: "Reload the page to use the newest version",
    reload: "Reload page now",
    title: "Update available!"
  },
  upload: "Upload",
  uploadFiles: {
    browse: "Browse file",
    deleteActiveImage: "Delete active Image",
    dragAndDrop: "Drag and drop files here",
    error: {
      "415": "Only .png files are allowed"
    },
    fileTooLarge: "{maxMbSize, plural, other {File size cannot exceed #MB, but the selected file is {fileMbSize}MB}}",
    noFileFound: "{fileCount, plural, one {No file found} other {No files found}}",
    or: "or",
    reallyDelete: "Delete this image? The previous image will be restored if available.",
    title: "Upload"
  },
  userGuid: "User Guid",
  users: {
    attributes: {
      connectedStores: "Connected Stores",
      firstName: "First Name",
      lastActiveOn: "Last Active On",
      lastName: "Last Name",
      notifications: "Notifications",
      onlineStatus: "Online Status",
      roles: "Roles",
      rolesAndNotifications: "Roles & ",
      userDetails: "User Details",
      userType: {
        global: "Global",
        store: "Store"
      },
      username: "Username"
    },
    dektopViewAction: "Switch to desktop view",
    loadMore: "Load More",
    mobileViewAction: "Switch to mobile view",
    moreConnectedStores: "more"
  },
  validation: {
    email: "No valid e-mail address",
    invalid: "Invalid",
    length: "Minimum length: {length, number}/8 characters",
    mandatory: "Mandatory field",
    passwordFailure: "Failed to update password: ",
    passwordRepeat: "Must match new password",
    passwordSaved: "Password saved successfully",
    unknownError: "Unknown error",
    userAlreadyUsed: "This username is already taken",
    userName: "Must be between {min, plural, other {#}} and {max, plural, other {# characters}}. Spaces are not allowed.",
    wrongPassword: "Wrong password"
  },
  validations: {
    email: "Invalid e-mail address",
    exactLength: "{count, plural, one {Has to be exactly # digit long} other {Has to be exactly # digits long}}",
    exactLength2: "Has to be exactly {count1} or {count2} digits long",
    invalidRegExp: "Not a valid RegExp",
    invalidType: "Invalid type",
    max: "Has to be less than or equal to {max, number}",
    maxGreaterThanMin: "Must be greater than the minimum",
    maxLength: "{count, plural, one {Can't be longer than # digit} other {Can't be longer than # digits}}",
    min: "Has to be greater than or equal to {min, number}",
    minLength: "{count, plural, one {Has to be at least # character long} other {Has to be at least # characters long}}",
    required: "Required"
  },
  versionConflict: "Another user has changed the data. Please reload the page and try again.",
  versions: {
    checking: "Checking for update",
    inProgress: "Update in progress",
    lookForUpdate: "Look for update",
    scheduled: "Update ready, page reload scheduled",
    title: "Versions",
    ui: "Store Manager UI"
  },
  voucherPromotion: {
    always: "Always",
    broadcast: "Broadcast",
    color: "Progress bar color",
    colorTitle: "Color",
    custom: "Custom",
    customColor: "Custom color",
    customerNote: "Customer note",
    date: "Date",
    "default": "Default",
    description: "Customer info",
    disclaimer: "Please note that discounts, vouchers, loyalty passes, as well as promotions in the {storeBrand} app can reduce the final amount at checkout. To receive a €5 voucher, the discountable amount at checkout must be €75.",
    isActive: "Currently active",
    minBasketAmount: "Minimum basket amount",
    permanent: "Permanent",
    preview: "Preview:",
    promotion: "Promotion",
    subtitle: "Subtitle",
    subtitleHelper: "Use '{minAmount}' and '{voucherAmount}' as placeholders for the promotion values defined below",
    templateSource: "The following progress bar promotion info is derived from the store setup template and will be saved in the store soon",
    title: "Title",
    voucherAmount: "Voucher amount",
    vouchers: "Vouchers"
  },
  welcome: {
    howDoesItWork: "How does it work?",
    payByPhone: "Pay By Phone",
    scanToLogin: "Scan To Log In",
    shopAnonymous: "Start Shopping",
    syncShoppingList: "Sync Your Shopping List",
    tutorial: {
      scanProducts: "Add products by scanning the barcode, or..."
    }
  },
  yes: "Yes"
} as const;
